import moment from "moment";
import diccionario from "@/imageDictionary.js";
import { 
    Table, 
    TableRow, 
    TableCell, 
    Paragraph, 
    ImageRun, 
    WidthType, 
    VerticalAlignTable, 
    HeightRule, 
    BorderStyle,
    AlignmentType,
    TextRun,
    TableLayoutType
 } from "docx";

export class InformeWordService {

    constructor(constantes) {
        this.constantes = constantes;
    }

    portada2025(anio, instalacion, logo) {
        let portada = new Table({
            width: {
                size: 100,
                type: WidthType.PERCENTAGE,
            },
            layout: TableLayoutType.FIXED,
            columnWidths: [2000, 5000, 3000],
            borders: {
                top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                bottom: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                left: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                right: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                insideHorizontal: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                insideVertical: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
            },
            rows: [
                new TableRow({
                    children: [
                        new TableCell({
                            width: { size: 20, type: WidthType.PERCENTAGE },
                            children: [
                                new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                        this.generateImageRun(diccionario.logoBanderaAzulDos, 100, 80)
                                    ]
                                })
                            ],
                            verticalAlign: VerticalAlignTable.CENTER,
                        }),
                        new TableCell({
                            width: { size: 55, type: WidthType.PERCENTAGE },
                            children: [new Paragraph({
                                children:[
                                    new TextRun( { text: 'VI Categoría:', font: "Arial", size: 30, color: '#1F497D', bold: true } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: 'Cambio Climático', font: "Arial", size: 30, color: '#1F497D', bold: true } ),
                                ], 
                                alignment: AlignmentType.CENTER
                            })],
                            verticalAlign: VerticalAlignTable.BOTTOM,
                        }),
                        new TableCell({
                            rowSpan: 2,
                            width: { size: 25, type: WidthType.PERCENTAGE },
                            margins: { top: 0, bottom: 0, left: 0, right: 0 },
                            children: [
                                new Paragraph({
                                    children: [
                                        new TextRun( { text: `${anio}`, font: "Arial", color: '#FFFFFF', size: 48, bold: true } )
                                    ],
                                    alignment: AlignmentType.CENTER,
                                })
                            ],
                            verticalAlign: VerticalAlignTable.TOP,
                            shading: {
                                fill: "#5084bc",
                            },
                        }),
                    ],
                }),
                new TableRow({
                    height: { value: 1000, rule: HeightRule.ATLEAST },
                    children: [
                        new TableCell( { columnSpan: 2, children: [ new Paragraph({}) ] } )
                    ]
                }),
                new TableRow({
                    height: { value: 400, rule: HeightRule.ATLEAST },
                    children: [
                        new TableCell({ 
                            columnSpan: 3,
                            width: { size: 100, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            shading: { fill: "#38849c" },
                            children: [ 
                                new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                        new TextRun({
                                            font: "Arial",
                                            text: 'Programa Bandera Azul Ecológica',  
                                            color: '#FFFFFF', 
                                            size: 25, 
                                            bold: true
                                        })
                                    ],

                                }) 
                            ] 
                        })
                    ]
                }),
                new TableRow({
                    height: { value: 1000, rule: HeightRule.ATLEAST },
                    children: [
                        new TableCell( { columnSpan: 2, width: { size: 75, type: WidthType.PERCENTAGE }, children: [ new Paragraph({}) ] } ),
                        new TableCell({
                            rowSpan: 7,
                            width: { size: 25, type: WidthType.PERCENTAGE },
                            margins: { top: 0, bottom: 0, left: 0, right: 0 },
                            children: [
                                new Paragraph({
                                    children: [
                                        new TextRun( { text: ``, font: "Arial", color: '#FFFFFF', size: 48, bold: true } )
                                    ],
                                    alignment: AlignmentType.CENTER,
                                })
                            ],
                            verticalAlign: VerticalAlignTable.TOP,
                            shading: {
                                fill: "#5084bc",
                            },
                        }),
                    ]
                }),
                new TableRow({
                    height: { value: 1000, rule: HeightRule.ATLEAST },
                    children: [
                        new TableCell( { 
                            columnSpan: 2, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            width: { size: 75, type: WidthType.PERCENTAGE }, 
                            children: [ new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [ new TextRun( { text: `Informe Final Año ${anio}`, font: "Arial", color: '#1F497D', size: 48, bold: true } )
                                ]
                            }) ] } ),
                    ]
                }),
                new TableRow({
                    height: { value: 1000, rule: HeightRule.ATLEAST },
                    children: [
                        new TableCell( { columnSpan: 2, width: { size: 75, type: WidthType.PERCENTAGE }, children: [ new Paragraph({}) ] } ),
                    ]
                }),
                new TableRow({
                    height: { value: 1000, rule: HeightRule.ATLEAST },
                    children: [
                        new TableCell( { 
                            columnSpan: 2, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            width: { size: 75, type: WidthType.PERCENTAGE }, 
                            children: [ 
                                new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [ new TextRun( { text: `${instalacion.codigoPbae} ${instalacion.nombre}`, font: "Arial", color: '#1F497D', size: 30, bold: true } ) ]
                            }) ] 
                        } ),
                    ]
                }),
                new TableRow({
                    height: { value: 1000, rule: HeightRule.ATLEAST },
                    children: [
                        new TableCell( { columnSpan: 2, width: { size: 75, type: WidthType.PERCENTAGE }, children: [ new Paragraph({}) ] } ),
                    ]
                }),
                new TableRow({
                    height: { value: 1000, rule: HeightRule.ATLEAST },
                    children: [
                        new TableCell( { 
                            columnSpan: 2, 
                            width: { size: 75, type: WidthType.PERCENTAGE }, 
                            children: [ 
                                new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                        this.generateImageRun(logo, 200, 100)
                                    ],
                                })
                            ] 
                        } ),
                    ]
                }),
                new TableRow({
                    height: { value: 4550, rule: HeightRule.ATLEAST },
                    children: [
                        new TableCell( { columnSpan: 2, width: { size: 75, type: WidthType.PERCENTAGE }, children: [ new Paragraph({}) ] } ),
                    ]
                }),
            ]
        })

        return portada
    }

    orgGeneralidades2025(datos, instalacion) {
        let historial = datos.historialEstrella;
        let dataRows = [
            new TableRow({
                children: [
                    new TableCell({
                        columnSpan: 4,
                        shading: { fill: '#8db3e2' },
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ children: [ new TextRun({ text: 'Nombre de la organización', font: 'Arial', size: 24 }) ] }) ]
                    }),
                    new TableCell({
                        columnSpan: 3,
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ children: [ new TextRun({ text: datos.organizacionNombre, font: 'Arial', size: 24 }) ] }) ]
                    })
                ]
            }),
            new TableRow({
                children: [
                    new TableCell({
                        columnSpan: 4,
                        shading: { fill: '#8db3e2' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ children: [ new TextRun({ text: 'Nombre de la sede', font: 'Arial', size: 24 }) ] }) ]
                    }),
                    new TableCell({
                        columnSpan: 3,
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ children: [ new TextRun({ text: instalacion.nombre, font: 'Arial', size: 24 }) ] }) ]
                    })
                ]
            }),
            new TableRow({
                children: [
                    new TableCell({
                        columnSpan: 4,
                        shading: { fill: '#8db3e2' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ children: [ new TextRun({ text: 'Código de comité', font: 'Arial', size: 24 }) ] }) ]
                    }),
                    new TableCell({
                        columnSpan: 3,
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ children: [ new TextRun({ text:  instalacion.codigoPbae, font: 'Arial', size: 24 }) ] }) ]
                    })
                ]
            }),
            new TableRow({
                children: [
                    new TableCell({
                        columnSpan: 4,
                        shading: { fill: '#8db3e2' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ children: [ new TextRun({ text: 'Cantidad de colaboradores/as', font: 'Arial', size: 24 }) ] }) ]
                    }),
                    new TableCell({
                        columnSpan: 3,
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ children: [ new TextRun({ text: `${instalacion.cantidadPersonal}`, font: 'Arial', size: 24 }) ] }) ]
                    })
                ]
            }),
            new TableRow({
                children: [
                    new TableCell({
                        columnSpan: 4,
                        shading: { fill: '#8db3e2' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ children: [ new TextRun({ text: 'Ubicación de la sede (provincia, cantón, distrito)', font: 'Arial', size: 24 }) ] }) ]
                    }),
                    new TableCell({
                        columnSpan: 3,
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ children: [ new TextRun({ text: `${instalacion.ubicacion} ${instalacion.direccion}`, font: 'Arial', size: 24 }) ] }) ]
                    })
                ]
            }),
            new TableRow({
                children: [
                    new TableCell({
                        columnSpan: 4,
                        shading: { fill: '#8db3e2' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ children: [ new TextRun({ text: 'Primera vez que presenta Informe Final (SI / NO)', font: 'Arial', size: 24 }) ] }) ]
                    }),
                    new TableCell({
                        columnSpan: 3,
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ children: [ new TextRun({ text: instalacion.tiempoEnPrograma > 0 ? "No" : "Si", font: 'Arial', size: 24 }) ] }) ]
                    })
                ]
            }),
            new TableRow({
                children: [
                    new TableCell({
                        columnSpan: 7,
                        shading: { fill: '#8db3e2' },
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({ 
                                alignment: AlignmentType.CENTER,
                                children: [ 
                                    new TextRun({ text: 'Historial de participación en la Categoría Cambio Climático', font: 'Arial', size: 24, bold: true }),
                                    new TextRun({ break: 1 }),
                                    new TextRun({ text: '(Si es primera vez que participan no completar. Para el histórico se contemplan 5 años anteriores)', font: 'Arial', size: 24 }) 
                                ] 
                            }) 
                        ]
                    })
                ]
            }),
            new TableRow({
                children: [
                    new TableCell({
                        rowSpan: 2,
                        shading: { fill: '#8db3e2' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: 'Año', font: 'Arial', size: 24 }) ] }) ]
                    }),
                    new TableCell({
                        columnSpan: 5,
                        shading: { fill: '#8db3e2' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: 'Resultado de la Evaluación', font: 'Arial', size: 24 }) ] }) ]
                    }),
                    new TableCell({
                        rowSpan: 2,
                        shading: { fill: '#8db3e2' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: 'Inscrita pero no presentó Informe Final', font: 'Arial', size: 24 }), new TextRun({ break: 1 }),  new TextRun({ text: '(marcar con X)', font: 'Arial', size: 16 }) ] }) ]
                    }),
                ]
            }),
            new TableRow({
                children: [
                    new TableCell({
                        shading: { fill: '#8db3e2' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({ 
                                alignment: AlignmentType.CENTER, 
                                children: [ 
                                    new TextRun({ text: 'Nota', font: 'Arial', size: 24 }), 
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: '(indicar número)', font: 'Arial', size: 16 }) 
                                ] 
                            }) 
                        ]
                    }),
                    new TableCell({
                        shading: { fill: '#8db3e2' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({ 
                                alignment: AlignmentType.CENTER, 
                                children: [ 
                                    new TextRun({ text: 'Estrellas Blancas', font: 'Arial', size: 24 }), 
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: '(indicar número)', font: 'Arial', size: 16 }) 
                                ] 
                            }) 
                        ]
                    }),
                    new TableCell({
                        shading: { fill: '#8db3e2' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({ 
                                alignment: AlignmentType.CENTER, 
                                children: [ 
                                    new TextRun({ text: 'Estrella Verde', font: 'Arial', size: 24 }), 
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: '(marcar con X)', font: 'Arial', size: 16 }) 
                                ] 
                            }) 
                        ]
                    }),
                    new TableCell({
                        shading: { fill: '#8db3e2' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({ 
                                alignment: AlignmentType.CENTER, 
                                children: [ 
                                    new TextRun({ text: 'Estrella Plateada', font: 'Arial', size: 24 }), 
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: '(marcar con X)', font: 'Arial', size: 16 }) 
                                ] 
                            }) 
                        ]
                    }),
                    new TableCell({
                        shading: { fill: '#8db3e2' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({ 
                                alignment: AlignmentType.CENTER, 
                                children: 
                                [ 
                                    new TextRun({ text: 'Estrella Anaranjada', font: 'Arial', size: 24 }), 
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: '(marcar con X)', font: 'Arial', size: 16 }) 
                                ] 
                            }) 
                        ]
                    }),
                ]
            }),
        ];

        //agrega filas de datos
        if(Array.isArray(historial) && historial.length > 0) {
            historial.forEach(h => {
                let row = new TableRow({
                    children: [
                        new TableCell({
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.CENTER, 
                                    children: [ new TextRun({ text: `${this.blankData(h.anio)}`, font: 'Arial', size: 24 }) ] 
                                }) 
                            ]
                        }),
                        new TableCell({
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.CENTER, 
                                    children: [ new TextRun({ text: `${this.blankData(h.nota)}`, font: 'Arial', size: 24 }) ] 
                                }) 
                            ]
                        }),
                        new TableCell({
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.CENTER, 
                                    children: [ new TextRun({ text: `${this.blankData(h.cantidadEstrellasBlancas)}`, font: 'Arial', size: 24 }) ] 
                                }) 
                            ]
                        }),
                        new TableCell({
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.CENTER, 
                                    children: [ new TextRun({ text: `${this.blankData(h.estrellaVerde)}`, font: 'Arial', size: 24 }) ] 
                                }) 
                            ]
                        }),
                        new TableCell({
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.CENTER, 
                                    children: [ new TextRun({ text: `${this.blankData(h.estrellaAnaranjada)}`, font: 'Arial', size: 24 }) ] 
                                }) 
                            ]
                        }),
                        new TableCell({
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.CENTER, 
                                    children: [ new TextRun({ text: `${this.blankData(h.estrellaPlateada)}`, font: 'Arial', size: 24 }) ] 
                                }) 
                            ]
                        }),
                        new TableCell({
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.CENTER, 
                                    children: [ new TextRun({ text: `${this.blankData(h.inscrita)}`, font: 'Arial', size: 24 }) ] 
                                }) 
                            ]
                        }),
                    ]
                })
                dataRows.push(row)
            });
        } else {
            let emptyRow = this.emptyTableRow(7);//7 columnas
            dataRows.push(emptyRow)
        }
        let galardon = this.rowtituloImagem('Foto que demuestre, la iza o exhibición de la bandera, del galardón PBAE obtenido el año anterior', datos.galardon, 7, '8db3e2');
        dataRows.push(...galardon)

        let generalidades = new Table({
            width: {
                size: 100,
                type: WidthType.PERCENTAGE,
            },
            rows: dataRows
        })

        return generalidades
    }

    resumenEjecutivo2025(instalacion, datos) {
        let resumen = new Table({
            width: {
                size: 100,
                type: WidthType.PERCENTAGE,
            },
            rows: [
                new TableRow({
                    height: { value: 3000, rule: HeightRule.ATLEAST },
                    children: [
                        new TableCell({
                            shading: { fill: '#8db3e2' }, 
                            width: { size: 40, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.LEFT, 
                                    children: [ new TextRun({ text: `Indique el alcance de la implementación del PBAE (límites físicos de aplicación: Edificio, plantel sedes, otros)`, font: 'Arial', size: 24 }) ] 
                                }) 
                            ]
                        }),
                        new TableCell({
                            verticalAlign: VerticalAlignTable.CENTER,
                            width: { size: 60, type: WidthType.PERCENTAGE }, 
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.LEFT, 
                                    children: [ new TextRun({ text: `${this.blankData(instalacion.alcance)}`, font: 'Arial', size: 24 }) ] 
                                }) 
                            ]
                        }),
                    ],
                }),
                new TableRow({
                    height: { value: 3000, rule: HeightRule.ATLEAST }, 
                    children: [
                        new TableCell({
                            shading: { fill: '#8db3e2' }, 
                            width: { size: 40, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.LEFT, 
                                    children: [ new TextRun({ text: `Describa en que consiste la actividad sustantiva que desarrolla la organización`, font: 'Arial', size: 24 }) ] 
                                }) 
                            ]
                        }),
                        new TableCell({
                            verticalAlign: VerticalAlignTable.CENTER,
                            width: { size: 60, type: WidthType.PERCENTAGE }, 
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.LEFT, 
                                    children: [ new TextRun({ text: `${this.blankData(datos.descripcionOrg)}`, font: 'Arial', size: 24 }) ] 
                                }) 
                            ]
                        }),
                    ],
                }),
                new TableRow({
                    height: { value: 3000, rule: HeightRule.ATLEAST },
                    children: [
                        new TableCell({
                            shading: { fill: '#8db3e2' }, 
                            width: { size: 40, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.LEFT, 
                                    children: [ new TextRun({ text: `Describa aspectos de la sede que considere relevantes de ser contemplados por el evaluador al momento de evaluar el informe final`, font: 'Arial', size: 24 }) ] 
                                }) 
                            ]
                        }),
                        new TableCell({
                            verticalAlign: VerticalAlignTable.CENTER,
                            width: { size: 60, type: WidthType.PERCENTAGE }, 
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.LEFT, 
                                    children: [ new TextRun({ text: `${this.blankData(instalacion.detalle)}`, font: 'Arial', size: 24 }) ] 
                                }) 
                            ]
                        }),
                    ],
                }),
            ]
        })

        return resumen;
    }

    flotaVehicular2025(flota) {
        let tableRows = [
                new TableRow({
                    children: [
                        new TableCell({
                            shading: { fill: '#8db3e2' }, 
                            width: { size: 20, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.CENTER, 
                                    children: [ new TextRun({ text: `Número de activo o Placa`, font: 'Arial', size: 24 }) ] 
                                }) 
                            ]
                        }),
                        new TableCell({
                            shading: { fill: '#8db3e2' }, 
                            width: { size: 20, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.CENTER, 
                                    children: [ new TextRun({ text: `Tipo de equipo`, font: 'Arial', size: 24 }) ] 
                                }) 
                            ]
                        }),
                        new TableCell({
                            shading: { fill: '#8db3e2' }, 
                            width: { size: 20, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.CENTER, 
                                    children: [ new TextRun({ text: `Marca`, font: 'Arial', size: 24 }) ] 
                                }) 
                            ]
                        }),
                        new TableCell({
                            shading: { fill: '#8db3e2' }, 
                            width: { size: 20, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.CENTER, 
                                    children: [ new TextRun({ text: `Año`, font: 'Arial', size: 24 }) ] 
                                }) 
                            ]
                        }),
                        new TableCell({
                            shading: { fill: '#8db3e2' }, 
                            width: { size: 20, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.CENTER, 
                                    children: [ new TextRun({ text: `Tipo de combustible fósil`, font: 'Arial', size: 24 }) ] 
                                }) 
                            ]
                        }),
                    ],
                }),
        ]

        //agrega filas de datos
        if(Array.isArray(flota) && flota.length > 0) {
            flota.forEach(v => {
                let dataRow = new TableRow({
                    children: [
                        new TableCell({
                            width: { size: 20, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.CENTER, 
                                    children: [ new TextRun({ text: `${v.numPlacaActivo}`, font: 'Arial', size: 24 }) ] 
                                }) 
                            ]
                        }),
                        new TableCell({
                            width: { size: 40, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.CENTER, 
                                    children: [ new TextRun({ text: `${v.tipoConsumidor}`, font: 'Arial', size: 24 }) ] 
                                }) 
                            ]
                        }),
                        new TableCell({
                            width: { size: 40, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.CENTER, 
                                    children: [ new TextRun({ text: `${v.marca}`, font: 'Arial', size: 24 }) ] 
                                }) 
                            ]
                        }),
                        new TableCell({
                            width: { size: 40, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.CENTER, 
                                    children: [ new TextRun({ text: `${v.anio}`, font: 'Arial', size: 24 }) ] 
                                }) 
                            ]
                        }),
                        new TableCell({
                            width: { size: 40, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.CENTER, 
                                    children: [ new TextRun({ text: `${v.tipoCombustible}`, font: 'Arial', size: 24 }) ] 
                                }) 
                            ]
                        }),
                    ],
                })
                tableRows.push(dataRow)
            })
        } else {
            let emptyRow = this.emptyTableRow(5);//5 columnas
            tableRows.push(emptyRow)
        }

        let flotaVehicular = new Table({
            width: {
                size: 100,
                type: WidthType.PERCENTAGE,
            },
            rows: tableRows
        })        
        return flotaVehicular;
    }

    base64ToUint8Array(base64) {
        // Elimina el prefijo si existe (ej. data:image/png;base64,)
        const rawBase64 = base64.split(',').pop();
        
        // Decodifica y convierte
        const binaryString = window.atob(rawBase64);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        
        for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes;
    }

    emptyTableRow(columns) {//recibe la cantidad de columnas requeridas
        let cols = []

        for(let col = 0; col < columns; col++) {
            let cell = new TableCell({
                verticalAlign: VerticalAlignTable.CENTER,
                children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: `N/A`, font: 'Arial', size: 24 }) ] }) ]
            })
            cols.push(cell)
        }
        
        let row = new TableRow({children: cols})
        return row;
    }

    blankData(data) {
        return data != undefined && data != null ? data : 'N/A';
    }

    rowtituloImagem(titulo, imagen, colSpan, rowColor) {
        let rows = []
        let rowTitulo = new TableRow({
            children: [
                new TableCell({
                    columnSpan: colSpan,
                    shading: { fill: rowColor }, 
                    verticalAlign: VerticalAlignTable.CENTER,
                    children: [ 
                        new Paragraph({ 
                            alignment: AlignmentType.LEFT, 
                            children: [ new TextRun({ text: `${this.blankData(titulo)}`, font: 'Arial', size: 24 }) ] 
                        }) 
                    ]
                })
            ]
        });
        rows.push(rowTitulo)
        if(imagen != undefined && imagen != null) {
            const tipo = this.detectarTipoImagen(imagen);
            let rowImagen = new TableRow({
                height: { value: 4000, rule: HeightRule.ATLEAST },
                children: [
                    new TableCell( { 
                        columnSpan: colSpan, 
                        width: { size: 100, type: WidthType.PERCENTAGE }, 
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new ImageRun({
                                        data: this.base64ToUint8Array(imagen),
                                        type: tipo,
                                        transformation: {
                                            width: 400,
                                            height: 300
                                        },
                                    }),
                                ],
                            })
                        ] 
                    } ),
                ]
            });
            rows.push(rowImagen)
        } else {
            let emptyImage = new TableRow({
                height: { value: 2000, rule: HeightRule.ATLEAST },
                children: [
                    new TableCell({
                        columnSpan: colSpan,
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({ 
                                alignment: AlignmentType.CENTER, 
                                children: [ new TextRun({ text: `N/A`, font: 'Arial', size: 24 }) ] 
                            }) 
                        ]
                    })
                ]
            });
            rows.push(emptyImage)
        }
        return rows;
    }

    justificacionConEvidencias(titulo, justificacion, evidencias, rowColor, isTrimestral) {
        rowColor = (isTrimestral != undefined && isTrimestral != null && isTrimestral) ? '#92cddc' : rowColor;
        let rows = []
        let rowTitulo = new TableRow({
            children: [
                new TableCell({
                    shading: { fill: rowColor }, 
                    verticalAlign: VerticalAlignTable.CENTER,
                    children: [ 
                        new Paragraph({ 
                            alignment: AlignmentType.LEFT, 
                            children: [ new TextRun({ text: `${this.blankData(titulo)}`, font: 'Arial', size: 24 }) ] 
                        }) 
                    ]
                })
            ]
        });
        rows.push(rowTitulo)
        let rowJustificacion = new TableRow({
            children: [
                new TableCell({
                    verticalAlign: VerticalAlignTable.CENTER,
                    children: [ 
                        new Paragraph({ 
                            alignment: AlignmentType.LEFT, 
                            children: [ new TextRun({ text: `${this.blankData(justificacion)}`, font: 'Arial', size: 24 }) ] 
                        }) 
                    ]
                })
            ]
        });
        rows.push(rowJustificacion)
        if(evidencias != undefined && evidencias != null && evidencias.length > 0) {
            evidencias.forEach(imagen => {
                let rowImagen = new TableRow({
                    height: { value: 4000, rule: HeightRule.ATLEAST },
                    children: [
                        new TableCell( { 
                            width: { size: 100, type: WidthType.PERCENTAGE }, 
                            children: [ 
                                new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                        this.generateImageRun(imagen, 400, 300)
                                    ],
                                })
                            ] 
                        } ),
                    ]
                });
                rows.push(rowImagen)
            })
        }
        
        let justifTable = new Table({
            width: {
                size: 100,
                type: WidthType.PERCENTAGE,
            },
            rows: rows
        })
        return justifTable;
    }

    tablaConsumo2025(titulo, tipDetalle, color, datos) {
        let rows = [
            new TableRow({
                children: [
                    new TableCell({ 
                        rowSpan: 2,
                        shading: { fill: color }, 
                        width: { size: 15, type: WidthType.PERCENTAGE }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `${this.blankData(tipDetalle)}`, font: 'Arial', size: 24 })
                                ],
                            })
                        ] 
                    }),
                    new TableCell({ 
                        columnSpan: 13,
                        shading: { fill: color }, 
                        width: { size: 85, type: WidthType.PERCENTAGE }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `${this.blankData(titulo)}`, font: 'Arial', size: 24 })
                                ],
                            })
                        ] 
                    }),
                ]
            }),
            new TableRow({
                children: [
                    new TableCell({ 
                        shading: { fill: color }, 
                        width: { size: 7, type: WidthType.PERCENTAGE }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: `Ene`, font: 'Arial', size: 24 }) ], }) ] 
                    }),
                    new TableCell({ 
                        shading: { fill: color }, 
                        width: { size: 7, type: WidthType.PERCENTAGE }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: `Feb`, font: 'Arial', size: 24 }) ], }) ] 
                    }),
                    new TableCell({ 
                        shading: { fill: color }, 
                        width: { size: 7, type: WidthType.PERCENTAGE }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: `Mar`, font: 'Arial', size: 24 }) ], }) ] 
                    }),
                    new TableCell({ 
                        shading: { fill: color }, 
                        width: { size: 7, type: WidthType.PERCENTAGE }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: `Abr`, font: 'Arial', size: 24 }) ], }) ] 
                    }),
                    new TableCell({ 
                        shading: { fill: color }, 
                        width: { size: 7, type: WidthType.PERCENTAGE }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: `Mayo`, font: 'Arial', size: 24 }) ], }) ] 
                    }),
                    new TableCell({ 
                        shading: { fill: color }, 
                        width: { size: 7, type: WidthType.PERCENTAGE }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: `Jun`, font: 'Arial', size: 24 }) ], }) ] 
                    }),
                    new TableCell({ 
                        shading: { fill: color }, 
                        width: { size: 7, type: WidthType.PERCENTAGE }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: `Jul`, font: 'Arial', size: 24 }) ], }) ] 
                    }),
                    new TableCell({ 
                        shading: { fill: color }, 
                        width: { size: 7, type: WidthType.PERCENTAGE }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: `Ago`, font: 'Arial', size: 24 }) ], }) ] 
                    }),
                    new TableCell({ 
                        shading: { fill: color }, 
                        width: { size: 7, type: WidthType.PERCENTAGE }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: `Sept`, font: 'Arial', size: 24 }) ], }) ] 
                    }),
                    new TableCell({ 
                        shading: { fill: color }, 
                        width: { size: 7, type: WidthType.PERCENTAGE }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: `Oct`, font: 'Arial', size: 24 }) ], }) ] 
                    }),
                    new TableCell({ 
                        shading: { fill: color }, 
                        width: { size: 7, type: WidthType.PERCENTAGE }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: `Nov`, font: 'Arial', size: 24 }) ], }) ] 
                    }),
                    new TableCell({ 
                        shading: { fill: color }, 
                        width: { size: 7, type: WidthType.PERCENTAGE }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: `Dic`, font: 'Arial', size: 24 }) ], }) ] 
                    }),
                    new TableCell({ 
                        shading: { fill: color }, 
                        width: { size: 9, type: WidthType.PERCENTAGE }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: `Total`, font: 'Arial', size: 24 }) ], }) ] 
                    }),
                ]
            })
        ]
        if(Array.isArray(datos) && datos.length > 0) {
            datos.forEach(c => {
                let dataRow = new TableRow({
                    children: [
                        new TableCell({ 
                            shading: { fill: color }, 
                            width: { size: 13, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.blankData(c.medidor), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                        new TableCell({ 
                            width: { size: 6, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(c.enero), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                        new TableCell({ 
                            width: { size: 6, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(c.febrero), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                        new TableCell({ 
                            width: { size: 6, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(c.marzo), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                        new TableCell({ 
                            width: { size: 6, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(c.abril), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                        new TableCell({ 
                            width: { size: 7, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(c.mayo), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                        new TableCell({ 
                            width: { size: 7, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(c.junio), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                        new TableCell({ 
                            width: { size: 7, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(c.julio), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                        new TableCell({ 
                            width: { size: 7, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(c.agosto), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                        new TableCell({ 
                            width: { size: 7, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(c.septiembre), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                        new TableCell({ 
                            width: { size: 7, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(c.octubre), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                        new TableCell({ 
                            width: { size: 7, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(c.noviembre), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                        new TableCell({ 
                            width: { size: 7, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(c.diciembre), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                        new TableCell({ 
                            width: { size: 9, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(c.total), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                    ]
                })
                rows.push(dataRow)
            })
        } else {
            let emptyRow = this.emptyTableRow(14)
            rows.push(emptyRow)
        }

        let consumoTable = new Table({
            width: {
                size: 100,
                type: WidthType.PERCENTAGE,
            },
            rows: rows
        })

        return consumoTable;
    }

    tablaConsumoAgua2025(titulo, tipDetalle, color, datos) {
        let rows = [
            new TableRow({
                children: [
                    new TableCell({ 
                        rowSpan: 2,
                        shading: { fill: color }, 
                        width: { size: 10, type: WidthType.PERCENTAGE }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `Uso`, font: 'Arial', size: 24 })
                                ],
                            })
                        ] 
                    }),
                    new TableCell({ 
                        rowSpan: 2,
                        shading: { fill: color }, 
                        width: { size: 10, type: WidthType.PERCENTAGE }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `${this.blankData(tipDetalle)}`, font: 'Arial', size: 24 })
                                ],
                            })
                        ] 
                    }),
                    new TableCell({ 
                        columnSpan: 13,
                        shading: { fill: color }, 
                        width: { size: 80, type: WidthType.PERCENTAGE }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `${this.blankData(titulo)}`, font: 'Arial', size: 24 })
                                ],
                            })
                        ] 
                    }),
                ]
            }),
            new TableRow({
                children: [
                    new TableCell({ 
                        shading: { fill: color }, 
                        width: { size: 6, type: WidthType.PERCENTAGE }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: `Ene`, font: 'Arial', size: 24 }) ], }) ] 
                    }),
                    new TableCell({ 
                        shading: { fill: color }, 
                        width: { size: 6, type: WidthType.PERCENTAGE }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: `Feb`, font: 'Arial', size: 24 }) ], }) ] 
                    }),
                    new TableCell({ 
                        shading: { fill: color }, 
                        width: { size: 6, type: WidthType.PERCENTAGE }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: `Mar`, font: 'Arial', size: 24 }) ], }) ] 
                    }),
                    new TableCell({ 
                        shading: { fill: color }, 
                        width: { size: 6, type: WidthType.PERCENTAGE }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: `Abr`, font: 'Arial', size: 24 }) ], }) ] 
                    }),
                    new TableCell({ 
                        shading: { fill: color }, 
                        width: { size: 6, type: WidthType.PERCENTAGE }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: `Mayo`, font: 'Arial', size: 24 }) ], }) ] 
                    }),
                    new TableCell({ 
                        shading: { fill: color }, 
                        width: { size: 6, type: WidthType.PERCENTAGE }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: `Jun`, font: 'Arial', size: 24 }) ], }) ] 
                    }),
                    new TableCell({ 
                        shading: { fill: color }, 
                        width: { size: 6, type: WidthType.PERCENTAGE }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: `Jul`, font: 'Arial', size: 24 }) ], }) ] 
                    }),
                    new TableCell({ 
                        shading: { fill: color }, 
                        width: { size: 6, type: WidthType.PERCENTAGE }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: `Ago`, font: 'Arial', size: 24 }) ], }) ] 
                    }),
                    new TableCell({ 
                        shading: { fill: color }, 
                        width: { size: 6, type: WidthType.PERCENTAGE }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: `Sept`, font: 'Arial', size: 24 }) ], }) ] 
                    }),
                    new TableCell({ 
                        shading: { fill: color }, 
                        width: { size: 6, type: WidthType.PERCENTAGE }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: `Oct`, font: 'Arial', size: 24 }) ], }) ] 
                    }),
                    new TableCell({ 
                        shading: { fill: color }, 
                        width: { size: 6, type: WidthType.PERCENTAGE }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: `Nov`, font: 'Arial', size: 24 }) ], }) ] 
                    }),
                    new TableCell({ 
                        shading: { fill: color }, 
                        width: { size: 6, type: WidthType.PERCENTAGE }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: `Dic`, font: 'Arial', size: 24 }) ], }) ] 
                    }),
                    new TableCell({ 
                        shading: { fill: color }, 
                        width: { size: 8, type: WidthType.PERCENTAGE }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: `Total`, font: 'Arial', size: 24 }) ], }) ] 
                    }),
                ]
            })
        ]
        if(Array.isArray(datos) && datos.length > 0) {
            datos.forEach(c => {
                let dataRow = new TableRow({
                    children: [
                        new TableCell({ 
                            shading: { fill: color }, 
                            width: { size: 10, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.blankData(c.detMedidor), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                        new TableCell({ 
                            shading: { fill: color }, 
                            width: { size: 10, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.blankData(c.medidor), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                        new TableCell({ 
                            width: { size: 6, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(c.enero), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                        new TableCell({ 
                            width: { size: 6, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(c.febrero), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                        new TableCell({ 
                            width: { size: 6, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(c.marzo), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                        new TableCell({ 
                            width: { size: 6, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(c.abril), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                        new TableCell({ 
                            width: { size: 6, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(c.mayo), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                        new TableCell({ 
                            width: { size: 6, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(c.junio), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                        new TableCell({ 
                            width: { size: 6, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(c.julio), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                        new TableCell({ 
                            width: { size: 6, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(c.agosto), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                        new TableCell({ 
                            width: { size: 6, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(c.septiembre), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                        new TableCell({ 
                            width: { size: 6, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(c.octubre), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                        new TableCell({ 
                            width: { size: 6, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(c.noviembre), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                        new TableCell({ 
                            width: { size: 6, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(c.diciembre), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                        new TableCell({ 
                            width: { size: 8, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(c.total), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                    ]
                })
                rows.push(dataRow)
            })
        } else {
            let emptyRow = this.emptyTableRow(15)
            rows.push(emptyRow)
        }

        let consumoTable = new Table({
            width: {
                size: 100,
                type: WidthType.PERCENTAGE,
            },
            rows: rows
        })

        return consumoTable;
    }

    detReduccion2025(anioAnterior, anio, indicador, isTrimestral) {
        let titulo;
        let subTitulo;
        switch (indicador) {
        case this.constantes.indicadorCombustibles:
            titulo = isTrimestral ? "Cuadro N°4-b" : 'Cuadro N°4-a';
            subTitulo = isTrimestral ? `Comparación de consumos de combustible fósil año ${anio}.` : `Comparación de consumos de combustible fósil del año ${anioAnterior}, con respecto al año ${anio}.`;
            break;
        case this.constantes.indicadorAgua:
            titulo = isTrimestral ? "Cuadro N°10-b" : 'Cuadro N°10-a';
            subTitulo = isTrimestral ? `Comparación de consumos de agua año ${anio}.` : `Comparación de consumos de agua del año ${anioAnterior}, con respecto al año ${anio}.`;
            break;
        case this.constantes.indicadorEnergia:
            titulo = isTrimestral ? "Cuadro N°17-b" : 'Cuadro N°17-a';
            subTitulo = isTrimestral ? `Comparación de consumos de energía eléctrica año ${anio}.` : `Comparación de consumos de energía eléctrica del año ${anioAnterior}, con respecto al año ${anio}.`;
            break;
        case this.constantes.indicadorResiduos:
            titulo = isTrimestral ? "Cuadro N°22-b" : 'Cuadro N°22-a';
            subTitulo = isTrimestral ? `Comparación de consumos de papel año ${anio}.` : `Comparación de consumos de papel del año ${anioAnterior}, con respecto al año ${anio}.`;
            break;
        case this.constantes.indicadorResiduosValorizables:
            titulo = isTrimestral ? "Cuadro N°25-b" : 'Cuadro N°25-a';
            subTitulo = isTrimestral ? `Comparación de generación residuos sólidos valorizables año ${anio}.` : `Comparación de generación residuos sólidos valorizables del año ${anioAnterior}, con respecto al año ${anio}.`;
            break;
        case this.constantes.indicadorResiduosNoValorizables:
            titulo = isTrimestral ? "Cuadro N°28-b" : 'Cuadro N°28-a';
            subTitulo = isTrimestral ? `Comparación de generación residuos no valorizables año ${anio}.` : `Comparación de generación residuos no valorizables del año ${anioAnterior}, con respecto al año ${anio}.`;
            break;
        }
        if(isTrimestral) {
            return new Paragraph({
                alignment: AlignmentType.CENTER,
                spacing: { after: 250, before:100 },
                children: [ 
                    new TextRun( { text: titulo, font: 'Arial', size: 28, color: '#365F91' } ),
                    new TextRun({ break: 1 }), 
                    new TextRun( { text: subTitulo, font: 'Arial', size: 28, color: '#365F91' } ),
                    new TextRun({ break: 1 }), 
                    new TextRun( { text: `(Este cuadro es exclusivo para sedes que no presentan consumos del año anterior)`, font: 'Arial', size: 28, color: '#365F91' } )
                ],
            });
        } else {
            return new Paragraph({
                alignment: AlignmentType.CENTER,
                spacing: { after: 250, before:100 },
                children: [ 
                    new TextRun( { text: titulo, font: 'Arial', size: 28, color: '#365F91' } ),
                    new TextRun({ break: 1 }), 
                    new TextRun( { text: subTitulo, font: 'Arial', size: 28, color: '#365F91' } ),
                ],
            });
        }
    }

    tablaReduccionPorTipo2025(indicador, datos, anioAnterior, anio, isTrimestral) {
        switch(indicador) {
            case this.constantes.indicadorCombustibles:
                return isTrimestral ? this.tablaReduccionTrimestral2025(datos, 'L', 'Tipo de Combustible') : this.tablaComparacionComb2025(datos, anioAnterior, anio);
            case this.constantes.indicadorAgua:
                return isTrimestral ? this.tablaReduccionTrimestral2025(datos, 'M3', 'USO') : this.tablaReduccionAgua2025(datos, anioAnterior, anio);
            case this.constantes.indicadorEnergia:
                return isTrimestral ? this.tablaReduccionTrimestral2025(datos, 'kW/h', 'Medidor') : this.tablaReduccionGenerica2025(datos, anioAnterior, anio, 'kW/h', 'Medidor', 'Colones', '(C) * Precio por kW/h', 'Ton CO2', 'eq evitadas (C) *(0.0000557)');
            case this.constantes.indicadorResiduos:
                return isTrimestral ? this.tablaReduccionTrimestral2025(datos, 'Resmas', 'Material') : this.tablaReduccionGenerica2025(datos, anioAnterior, anio, 'Resmas', 'Material', 'Árboles', '(Ahorro en resmas*0,049)', 'Dinero', '(Ahorro en resmas*precio de la resma)');
            case this.constantes.indicadorResiduosValorizables:
                return isTrimestral ? this.tablaReduccionTrimestral2025(datos, 'Kg', 'Tipo de residuo valorizable') : this.tablaReduccionResiduosValor2025(datos, anioAnterior, anio);
            case this.constantes.indicadorResiduosNoValorizables:
                return isTrimestral ? this.tablaReduccionTrimestral2025(datos, 'Kg', 'Tipo de residuo No valorizable') : this.tablaReduccionResiduosNoVal2025(datos, anioAnterior, anio, false);
        }
    }

    tablaReduccionAgua2025(datos, anioAnterior, anio) {
        let datRows = [];
        let rows = [
            new TableRow({
                children: [
                    new TableCell({ 
                        columnSpan: 5,
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.TOP,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `DATOS ESTRICTAMENTE REQUERIDOS`, font: 'Arial', size: 24, bold: true })
                                ],
                            })
                        ] 
                    }),
                    new TableCell({ 
                        rowSpan: 2,
                        columnSpan: 4,
                        shading: { fill: '#c2d69b' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `EQUIVALENCIAS`, font: 'Arial', size: 24, bold: true }),
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: `(Datos no obligatorios)`, font: 'Arial', size: 24 }),
                                ],
                            })
                        ] 
                    }),
                ]
            }),
            new TableRow({
                children: [
                    new TableCell({ 
                        rowSpan: 2,
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.TOP,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `Uso`, font: 'Arial', size: 24 })
                                ],
                            })
                        ] 
                    }),
                    new TableCell({ 
                        columnSpan: 2,
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `Consumo Total (m3)`, font: 'Arial', size: 24 })
                                ],
                            })
                        ] 
                    }),
                    new TableCell({ 
                        columnSpan: 2,
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `Ahorro (en m3)`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: `(A)-(B)`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: `(C)`, font: 'Arial', size: 24, bold: true }),
                                ],
                            })
                        ] 
                    }),
                ]
            }),
            new TableRow({
                children: [
                    new TableCell({ 
                        shading: { fill: '#fabf8f' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `Anterior`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: `${anioAnterior}`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: `(A)`, font: 'Arial', size: 24, bold: true }),
                                ],
                            })
                        ] 
                    }),
                    new TableCell({ 
                        shading: { fill: '#8db3e2' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `Actual`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: `${anio}`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: `(B)`, font: 'Arial', size: 24, bold: true }),
                                ],
                            })
                        ] 
                    }),
                    new TableCell({ 
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `Cifra del resultado de la resta`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: `(números)`, font: 'Arial', size: 24 })
                                ],
                            })
                        ] 
                    }),
                    new TableCell({ 
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `Escriba en letras el resultado de la resta`, font: 'Arial', size: 24 })
                                ],
                            })
                        ] 
                    }),
                    new TableCell({ 
                        shading: { fill: '#c2d69b' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `Colones`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: `(C) * Precio por m3 de agua`, font: 'Arial', size: 24 })
                                ],
                            })
                        ] 
                    }),
                    new TableCell({ 
                        shading: { fill: '#c2d69b' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `Bidones para agua de 20 L`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: `(C) * 50`, font: 'Arial', size: 24 })
                                ],
                            })
                        ] 
                    }),
                    new TableCell({ 
                        shading: { fill: '#c2d69b' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `Tanques de almacenamiento de agua de 750 L`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: `(C) * 1,333`, font: 'Arial', size: 24 })
                                ],
                            })
                        ] 
                    }),
                    new TableCell({ 
                        shading: { fill: '#c2d69b' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `Piscinas Olímpicas`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: `(C) / 2500`, font: 'Arial', size: 24 })
                                ],
                            })
                        ] 
                    }),
                ]
            }),
        ]
        if(Array.isArray(datos) && datos.length > 0) {
            datos.forEach(d => {
                let row = new TableRow({
                    children: [
                        new TableCell({ 
                            shading: { fill: '#92cddc' }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.blankData(d.nombre), font: 'Arial', size: 24 }) ] }) ] 
                        }),
                        new TableCell({ 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(d.consumoAnterior), font: 'Arial', size: 24 }) ] }) ] 
                        }),
                        new TableCell({ 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(d.consumoActual), font: 'Arial', size: 24 }) ] }) ] 
                        }),
                        new TableCell({ 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(d.ahorroConsumo), font: 'Arial', size: 24 }) ] }) ] 
                        }),
                        new TableCell({ 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.blankData(d.consumoWords), font: 'Arial', size: 24 }) ] }) ] 
                        }),
                        new TableCell({ 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(d.ahorroColones), font: 'Arial', size: 24 }) ] }) ] 
                        }),
                        new TableCell({ 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(d.bidones), font: 'Arial', size: 24 }) ] }) ] 
                        }),
                        new TableCell({ 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(d.tanquesAgua), font: 'Arial', size: 24 }) ] }) ] 
                        }),
                        new TableCell({ 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(d.piscinasOlimp), font: 'Arial', size: 24 }) ] }) ] 
                        }),
                    ]
                })
                datRows.push(row)
            })
        } else {
            let emptyRows = this.emptyTableRow(9)
            datRows.push(...emptyRows)
        }
        rows.push(...datRows)
        let table = new Table({
            width: {
                size: 100,
                type: WidthType.PERCENTAGE,
            },
            rows: rows
        })
        return table
    }

    tablaComparacionComb2025(datos, anioAnterior, anio) {
        let rows = [
            new TableRow({
                children: [
                    new TableCell({ 
                        columnSpan: 5,
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.TOP,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `DATOS ESTRICTAMENTE REQUERIDOS`, font: 'Arial', size: 24, bold: true })
                                ],
                            })
                        ] 
                    }),
                    new TableCell({ 
                        shading: { fill: '#c2d69b' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `EQUIVALENCIAS`, font: 'Arial', size: 24, bold: true }),
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: `(Datos no obligatorios)`, font: 'Arial', size: 24 }),
                                ],
                            })
                        ] 
                    }),
                ]
            }),
            new TableRow({
                children: [
                    new TableCell({ 
                        rowSpan: 2,
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: `Tipo de Combustible`, font: 'Arial', size: 24 }) ], }) ] 
                    }),
                    new TableCell({ 
                        columnSpan: 2,
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: `Consumo Total (litros)`, font: 'Arial', size: 24 }) ], }) ] 
                    }),
                    new TableCell({ 
                        columnSpan: 2,
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({ alignment: AlignmentType.CENTER, children: [ 
                                    new TextRun({ text: `Ahorro (en litros)`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }),
                                    new TextRun({ text: `(A)-(B)`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }),
                                    new TextRun({ text: `(C)`, font: 'Arial', size: 24, bold: true })
                                ], 
                            }),
                        ] 
                    }),
                    new TableCell({ 
                        rowSpan: 2,
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({ alignment: AlignmentType.CENTER, children: [ 
                                    new TextRun({ text: `Colones ahorrados`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }),
                                    new TextRun({ text: `(C) * Precio por litro de combustible`, font: 'Arial', size: 24 })
                                ]
                            })
                        ] 
                    }),
                ]
            }),
            new TableRow({
                children: [
                    new TableCell({ 
                        shading: { fill: '#fabf8f' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({ alignment: AlignmentType.CENTER, children: [ 
                                    new TextRun({ text: `Anterior`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }),
                                    new TextRun({ text: `${anioAnterior}`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }),
                                    new TextRun({ text: `(A)`, font: 'Arial', size: 24, bold: true })
                                ]
                            })
                        ] 
                    }),
                    new TableCell({ 
                        shading: { fill: '#8db3e2' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({ alignment: AlignmentType.CENTER, children: [ 
                                    new TextRun({ text: `Actual`, font: 'Arial', size: 24 }), 
                                    new TextRun({ break: 1 }),
                                    new TextRun({ text: `${anio}`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }),
                                    new TextRun({ text: `(B)`, font: 'Arial', size: 24, bold: true })
                                ]
                            })
                        ] 
                    }),
                    new TableCell({ 
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({ alignment: AlignmentType.CENTER, children: [ 
                                    new TextRun({ text: `Cifra del resultado de la resta`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }),
                                    new TextRun({ text: `(números)`, font: 'Arial', size: 24 })
                                ]
                            })
                        ] 
                    }),
                    new TableCell({ 
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.TOP,
                        children: [ 
                            new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: `Escriba en letras el resultado de la resta`, font: 'Arial', size: 24 }) ], }),
                        ] 
                    }),
                ]
            })
        ]
        if(Array.isArray(datos) && datos.length > 0) {
            datos.forEach(c => {
                let dataRow = new TableRow({
                    children: [
                        new TableCell({ 
                            shading: { fill: '#92cddc' }, 
                            width: { size: 9, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: c.nombre, font: 'Arial', size: 24 }) ], }) ] 
                        }),
                        new TableCell({ 
                            width: { size: 7, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(c.consumoAnterior), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                        new TableCell({ 
                            width: { size: 7, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(c.consumoActual), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                        new TableCell({ 
                            width: { size: 7, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(c.ahorroConsumo), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                        new TableCell({ 
                            width: { size: 20, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.blankData(c.consumoWords), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                        new TableCell({ 
                            width: { size: 20, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(c.ahorroColones), font: 'Arial', size: 24 }) ], }) ] 
                        })
                    ]
                })
                rows.push(dataRow)
            })
        } else {
            let emptyRow = this.emptyTableRow(6)
            rows.push(emptyRow)
        }

        let compTable = new Table({
            width: {
                size: 100,
                type: WidthType.PERCENTAGE,
            },
            layout: TableLayoutType.FIXED,
            rows: rows
        })

        return compTable;
    }

    tablaReduccionGenerica2025(datos, anioAnterior, anio, unidad, detalle, detEqUno, formulaUno, detEqDos, formulaDos) {
        let datRows = [];
        let rows = [
            new TableRow({
                children: [
                    new TableCell({ 
                        columnSpan: 5,
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.TOP,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `DATOS ESTRICTAMENTE REQUERIDOS`, font: 'Arial', size: 24, bold: true })
                                ],
                            })
                        ] 
                    }),
                    new TableCell({ 
                        columnSpan: 2,
                        shading: { fill: '#c2d69b' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `EQUIVALENCIAS`, font: 'Arial', size: 24, bold: true }),
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: `(Datos no obligatorios)`, font: 'Arial', size: 24 }),
                                ],
                            })
                        ] 
                    }),
                ]
            }),
            new TableRow({
                children: [
                    new TableCell({ 
                        rowSpan: 2,
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.TOP,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: detalle, font: 'Arial', size: 24 })
                                ],
                            })
                        ] 
                    }),
                    new TableCell({ 
                        columnSpan: 2,
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `Consumo Total (${unidad})`, font: 'Arial', size: 24 })
                                ],
                            })
                        ] 
                    }),
                    new TableCell({ 
                        columnSpan: 2,
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `Ahorro (en ${unidad})`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: `(A)-(B)`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: `(C)`, font: 'Arial', size: 24, bold: true }),
                                ],
                            })
                        ] 
                    }),
                    new TableCell({ 
                        rowSpan: 2,
                        shading: { fill: '#c2d69b' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: detEqUno, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: formulaUno, font: 'Arial', size: 24 }),
                                ],
                            })
                        ] 
                    }),
                    new TableCell({ 
                        rowSpan: 2,
                        shading: { fill: '#c2d69b' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: detEqDos, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: formulaDos, font: 'Arial', size: 24 }),
                                ],
                            })
                        ] 
                    }),
                ]
            }),
            new TableRow({
                children: [
                    new TableCell({ 
                        shading: { fill: '#fabf8f' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `Anterior`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: `${anioAnterior}`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: `(A)`, font: 'Arial', size: 24, bold: true }),
                                ],
                            })
                        ] 
                    }),
                    new TableCell({ 
                        shading: { fill: '#8db3e2' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `Actual`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: `${anio}`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: `(B)`, font: 'Arial', size: 24, bold: true }),
                                ],
                            })
                        ] 
                    }),
                    new TableCell({ 
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `Cifra del resultado de la resta`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: `(números)`, font: 'Arial', size: 24 })
                                ],
                            })
                        ] 
                    }),
                    new TableCell({ 
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `Escriba en letras el resultado de la resta`, font: 'Arial', size: 24 })
                                ],
                            })
                        ] 
                    })
                ]
            }),
        ]
        if(Array.isArray(datos) && datos.length > 0) {
            datos.forEach(d => {
                let row = new TableRow({
                    children: [
                        new TableCell({ 
                            shading: { fill: '#92cddc' }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.blankData(d.nombre), font: 'Arial', size: 24 }) ] }) ] 
                        }),
                        new TableCell({ 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(d.consumoAnterior), font: 'Arial', size: 24 }) ] }) ] 
                        }),
                        new TableCell({ 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(d.consumoActual), font: 'Arial', size: 24 }) ] }) ] 
                        }),
                        new TableCell({ 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(d.ahorroConsumo), font: 'Arial', size: 24 }) ] }) ] 
                        }),
                        new TableCell({ 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.blankData(d.consumoWords), font: 'Arial', size: 24 }) ] }) ] 
                        }),
                        new TableCell({ 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(d.ahorroColones), font: 'Arial', size: 24 }) ] }) ] 
                        }),
                        new TableCell({ 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(d.tonC02), font: 'Arial', size: 24 }) ] }) ] 
                        })
                    ]
                })
                datRows.push(row)
            })
        } else {
            let emptyRows = this.emptyTableRow(7)
            datRows.push(...emptyRows)
        }
        rows.push(...datRows)
        let table = new Table({
            width: {
                size: 100,
                type: WidthType.PERCENTAGE,
            },
            rows: rows
        })
        return table
    }

    tablaReduccionResiduosNoVal2025(datos, anioAnterior, anio, isValorizable) {
        let detalle = 'Tipo de residuo valorizable';
        let datRows = [];
        let rows = [
            new TableRow({
                children: [
                    new TableCell({ 
                        columnSpan: 5,
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.TOP,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `DATOS ESTRICTAMENTE REQUERIDOS`, font: 'Arial', size: 24, bold: true })
                                ],
                            })
                        ] 
                    }),
                    new TableCell({ 
                        rowSpan: 2,
                        shading: { fill: '#c2d69b' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `EQUIVALENCIAS`, font: 'Arial', size: 24, bold: true }),
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: `(Datos no obligatorios)`, font: 'Arial', size: 24 }),
                                ],
                            })
                        ] 
                    }),
                ]
            }),
            new TableRow({
                children: [
                    new TableCell({ 
                        rowSpan: 2,
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: detalle, font: 'Arial', size: 24 })
                                ],
                            })
                        ] 
                    }),
                    new TableCell({ 
                        columnSpan: 2,
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `Generación Total (Kg)`, font: 'Arial', size: 24 })
                                ],
                            })
                        ] 
                    }),
                    new TableCell({ 
                        columnSpan: 2,
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `Reducción`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: `(A)-(B)`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: `(C)`, font: 'Arial', size: 24, bold: true }),
                                ],
                            })
                        ] 
                    }),
                ]
            }),
            new TableRow({
                children: [
                    new TableCell({ 
                        shading: { fill: '#fabf8f' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `Anterior`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: `${anioAnterior}`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: `(A)`, font: 'Arial', size: 24, bold: true }),
                                ],
                            })
                        ] 
                    }),
                    new TableCell({ 
                        shading: { fill: '#8db3e2' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `Actual`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: `${anio}`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: `(B)`, font: 'Arial', size: 24, bold: true }),
                                ],
                            })
                        ] 
                    }),
                    new TableCell({ 
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `Cifra del resultado de la resta`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: `(números)`, font: 'Arial', size: 24 })
                                ],
                            })
                        ] 
                    }),
                    new TableCell({ 
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `Escriba en letras el resultado de la resta`, font: 'Arial', size: 24 })
                                ],
                            })
                        ] 
                    }),
                    new TableCell({ 
                        shading: { fill: '#c2d69b' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `Contenedor industrial`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: `C/450`, font: 'Arial', size: 24 })
                                ],
                            })
                        ] 
                    })
                ]
            }),
        ]
        if(Array.isArray(datos) && datos.length > 0) {
            datos.forEach(d => {
                let row = new TableRow({
                    children: [
                        new TableCell({ 
                            shading: { fill: '#92cddc' }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.blankData(d.nombre), font: 'Arial', size: 24 }) ] }) ] 
                        }),
                        new TableCell({ 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(d.consumoAnterior), font: 'Arial', size: 24 }) ] }) ] 
                        }),
                        new TableCell({ 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(d.consumoActual), font: 'Arial', size: 24 }) ] }) ] 
                        }),
                        new TableCell({ 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(d.ahorroConsumo), font: 'Arial', size: 24 }) ] }) ] 
                        }),
                        new TableCell({ 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.blankData(d.consumoWords), font: 'Arial', size: 24 }) ] }) ] 
                        }),
                        new TableCell({ 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(d.contenedorIndustrial), font: 'Arial', size: 24 }) ] }) ] 
                        })
                    ]
                })
                datRows.push(row)
            })
        } else {
            let emptyRows = this.emptyTableRow(6)
            datRows.push(emptyRows)
        }
        rows.push(...datRows)
        let table = new Table({
            width: {
                size: 100,
                type: WidthType.PERCENTAGE,
            },
            rows: rows
        })
        return table
    }

    tablaReduccionResiduosValor2025(datos, anioAnterior, anio) {
        let detalle = 'Tipo de residuo valorizable';
        let datRows = [];
        let rows = [
            new TableRow({
                children: [
                    new TableCell({ 
                        rowSpan: 2,
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: detalle, font: 'Arial', size: 24 })
                                ],
                            })
                        ] 
                    }),
                    new TableCell({ 
                        columnSpan: 2,
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `Generación Total (Kg)`, font: 'Arial', size: 24 })
                                ],
                            })
                        ] 
                    }),
                    new TableCell({ 
                        columnSpan: 2,
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `Reducción`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: `(A)-(B)`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: `(C)`, font: 'Arial', size: 24, bold: true }),
                                ],
                            })
                        ] 
                    }),
                ]
            }),
            new TableRow({
                children: [
                    new TableCell({ 
                        shading: { fill: '#fabf8f' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `Anterior`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: `${anioAnterior}`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: `(A)`, font: 'Arial', size: 24, bold: true }),
                                ],
                            })
                        ] 
                    }),
                    new TableCell({ 
                        shading: { fill: '#8db3e2' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `Actual`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: `${anio}`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: `(B)`, font: 'Arial', size: 24, bold: true }),
                                ],
                            })
                        ] 
                    }),
                    new TableCell({ 
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `Cifra del resultado de la resta`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: `(números)`, font: 'Arial', size: 24 })
                                ],
                            })
                        ] 
                    }),
                    new TableCell({ 
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({ text: `Escriba en letras el resultado de la resta`, font: 'Arial', size: 24 })
                                ],
                            })
                        ] 
                    })
                ]
            }),
        ]
        if(Array.isArray(datos) && datos.length > 0) {
            datos.forEach(d => {
                let row = new TableRow({
                    children: [
                        new TableCell({ 
                            shading: { fill: '#92cddc' }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.blankData(d.nombre), font: 'Arial', size: 24 }) ] }) ] 
                        }),
                        new TableCell({ 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(d.consumoAnterior), font: 'Arial', size: 24 }) ] }) ] 
                        }),
                        new TableCell({ 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(d.consumoActual), font: 'Arial', size: 24 }) ] }) ] 
                        }),
                        new TableCell({ 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(d.ahorroConsumo), font: 'Arial', size: 24 }) ] }) ] 
                        }),
                        new TableCell({ 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.blankData(d.consumoWords), font: 'Arial', size: 24 }) ] }) ] 
                        })
                    ]
                })
                datRows.push(row)
            })
        } else {
            let emptyRows = this.emptyTableRow(5)
            datRows.push(emptyRows)
        }
        rows.push(...datRows)
        let table = new Table({
            width: {
                size: 100,
                type: WidthType.PERCENTAGE,
            },
            rows: rows
        })
        return table
    }

    tablaReduccionTrimestral2025(datos, unidad, detalle) {
        let rows = [
            new TableRow({
                children: [
                    new TableCell({ 
                        rowSpan: 2,
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.TOP,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [ new TextRun({ text: detalle, font: 'Arial', size: 24 }) ],
                            })
                        ] 
                    }),
                    new TableCell({ 
                        columnSpan: 4,
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [ new TextRun({ text: `Consumo Total (${unidad})`, font: 'Arial', size: 24 }) ]
                            })
                        ] 
                    }),
                    new TableCell({ 
                        rowSpan: 2,
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [ 
                                    new TextRun({ text: `Promedio del segundo, tercer y cuarto trimestre`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }),
                                    new TextRun({ text: `(E)`, font: 'Arial', size: 24, bold: true })
                                ]
                            })
                        ] 
                    }),
                    new TableCell({ 
                        columnSpan: 2,
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [ 
                                    new TextRun({ text: `Ahorro (en ${unidad})`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }),
                                    new TextRun({ text: `(A)-(E)`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }),
                                    new TextRun({ text: `(F)`, font: 'Arial', size: 24, bold: true })
                                ]
                            })
                        ] 
                    }),
                ]
            }),
            new TableRow({
                children: [
                    new TableCell({ 
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({ alignment: AlignmentType.CENTER, children: [ 
                                new TextRun({ text: `Promedio Primer trimestre`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }),
                                    new TextRun({ text: `(A)`, font: 'Arial', size: 24, bold: true }),
                                ], 
                            }), 
                        ] 
                    }),
                    new TableCell({ 
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({ alignment: AlignmentType.CENTER, children: [ 
                                new TextRun({ text: `Promedio Segundo trimestre`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }),
                                    new TextRun({ text: `(B)`, font: 'Arial', size: 24, bold: true }),
                                ], 
                            }), 
                        ] 
                    }),
                    new TableCell({ 
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({ alignment: AlignmentType.CENTER, children: [ 
                                new TextRun({ text: `Promedio Tercer trimestre`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }),
                                    new TextRun({ text: `(C)`, font: 'Arial', size: 24, bold: true }),
                                ], 
                            }), 
                        ] 
                    }),
                    new TableCell({ 
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({ alignment: AlignmentType.CENTER, children: [ 
                                new TextRun({ text: `Promedio Cuarto trimestre`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }),
                                    new TextRun({ text: `(D)`, font: 'Arial', size: 24, bold: true }),
                                ], 
                            }), 
                        ] 
                    }),
                    new TableCell({ 
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({ alignment: AlignmentType.CENTER, children: [ 
                                new TextRun({ text: `Cifra del resultado de la resta`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }),
                                    new TextRun({ text: `(números)`, font: 'Arial', size: 24 }),
                                ], 
                            }), 
                        ] 
                    }),
                    new TableCell({ 
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: `Escriba en letras el resultado de la resta `, font: 'Arial', size: 24 })]}) 
                        ] 
                    }),
                ]
            })
        ]
        if(Array.isArray(datos) && datos.length > 0) {
            datos.forEach(c => {
                let dataRow = new TableRow({
                    children: [
                        new TableCell({ 
                            shading: { fill: '#92cddc' }, 
                            width: { size: 13, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.blankData(c.nombre), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                        new TableCell({ 
                            width: { size: 6, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(c.primerTrimestre), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                        new TableCell({ 
                            width: { size: 6, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(c.segundoTrimestre), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                        new TableCell({ 
                            width: { size: 6, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(c.tercerTrimestre), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                        new TableCell({ 
                            width: { size: 6, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(c.cuartoTrimestre), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                        new TableCell({ 
                            width: { size: 6, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(c.promSegTercuaTrimestre), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                        new TableCell({ 
                            width: { size: 7, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.numberFormat(c.ahorroConsumo), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                        new TableCell({ 
                            width: { size: 13, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.blankData(c.consumoWords), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                    ]
                })
                rows.push(dataRow)
            })
        } else {
            let emptyRow = this.emptyTableRow(8)
            rows.push(emptyRow)
        }

        let compTable = new Table({
            width: {
                size: 100,
                type: WidthType.PERCENTAGE,
            },
            rows: rows
        })

        return compTable;
    }   

    educacionAmbiental2025(datos) {
        let tables= []
        if(Array.isArray(datos) && datos.length > 0) {
            datos.forEach((e, index) => {   
                let numActividad = index + 1;
                let modalidad = `Virtual: ${e.modalidad.nombre === "Virtual" ? "X" : "______"}\nPresencial: ${e.modalidad.nombre === "Presencial" ? "X" : "______"}`;
		        let participantes = `Colaboradores: ${e.listaParticipante != null && e.listaParticipante.includes("Colaboradores") ? "X" : "______"}
                        Clientes / Proveedores / Comunidad / Otros: ${e.listaParticipante != null && e.listaParticipante.includes("Clientes" || "Proveedores" || "Comunidad" || "Otros") ? "X" : "______"}`;
                let rows = [
                    new TableRow({
                        children: [
                            new TableCell({
                                columnSpan: 2,
                                shading: { fill: '#4bacc6' }, 
                                verticalAlign: VerticalAlignTable.CENTER,
                                width: { size: 100, type: WidthType.PERCENTAGE },
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.LEFT, 
                                        children: [ 
                                            new TextRun({ text: `Actividad N°${numActividad}:`, font: 'Arial', size: 24, bold: true, color: '#000000' })
                                        ]
                                    }) 
                                ] 
                            })
                        ]
                    }),
                    new TableRow({
                        children: [
                            new TableCell({
                                shading: { fill: '#8db3e2' }, 
                                verticalAlign: VerticalAlignTable.CENTER,
                                width: { size: 55, type: WidthType.PERCENTAGE },
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.LEFT, 
                                        children: [ 
                                            new TextRun({ text: `Nombre de la actividad y del facilitador:`, font: 'Arial', size: 24 })
                                        ]
                                    }) 
                                ] 
                            }),
                            new TableCell({
                                shading: { fill: '#8db3e2' }, 
                                verticalAlign: VerticalAlignTable.CENTER,
                                width: { size: 45, type: WidthType.PERCENTAGE },
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.LEFT, 
                                        children: [ 
                                            new TextRun({ text: `Fecha de la actividad:`, font: 'Arial', size: 24 })
                                        ]
                                    }) 
                                ] 
                            })
                        ]
                    }),
                    new TableRow({
                        children: [
                            new TableCell({
                                verticalAlign: VerticalAlignTable.CENTER,
                                width: { size: 55, type: WidthType.PERCENTAGE },
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.LEFT, 
                                        children: [ 
                                            new TextRun({ text: this.dataEducacion(e.tipoActividad, e.facilitador), font: 'Arial', size: 24 })
                                        ]
                                    }) 
                                ] 
                            }),
                            new TableCell({
                                verticalAlign: VerticalAlignTable.CENTER,
                                width: { size: 45, type: WidthType.PERCENTAGE },
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.LEFT, 
                                        children: [ 
                                            new TextRun({ text: moment(e.fechaActividad).format("DD/MM/YYYY"), font: 'Arial', size: 24 })
                                        ]
                                    }) 
                                ] 
                            })
                        ]
                    }),
                    new TableRow({
                        children: [
                            new TableCell({
                                columnSpan: 2,
                                shading: { fill: '#8db3e2' }, 
                                verticalAlign: VerticalAlignTable.CENTER,
                                width: { size: 100, type: WidthType.PERCENTAGE },
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.LEFT, 
                                        children: [ 
                                            new TextRun({ text: `Descripción y temas tratados:`, font: 'Arial', size: 24 })
                                        ]
                                    }) 
                                ] 
                            })
                        ]
                    }),
                    new TableRow({
                        children: [
                            new TableCell({
                                columnSpan: 2,
                                verticalAlign: VerticalAlignTable.CENTER,
                                width: { size: 100, type: WidthType.PERCENTAGE },
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.LEFT, 
                                        children: [ 
                                            new TextRun({ text: e.descripcion, font: 'Arial', size: 24 })
                                        ]
                                    }) 
                                ] 
                            })
                        ]
                    }),
                    new TableRow({
                        children: [
                            new TableCell({
                                shading: { fill: '#8db3e2' }, 
                                verticalAlign: VerticalAlignTable.CENTER,
                                width: { size: 55, type: WidthType.PERCENTAGE },
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.LEFT, 
                                        children: [ 
                                            new TextRun({ text: `Público participante (marque con x):`, font: 'Arial', size: 24 })
                                        ]
                                    }) 
                                ] 
                            }),
                            new TableCell({
                                shading: { fill: '#8db3e2' }, 
                                verticalAlign: VerticalAlignTable.CENTER,
                                width: { size: 45, type: WidthType.PERCENTAGE },
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.LEFT, 
                                        children: [ 
                                            new TextRun({ text: `Modalidad de la actividad (marque con x):`, font: 'Arial', size: 24 })
                                        ]
                                    }) 
                                ] 
                            })
                        ]
                    }),
                    new TableRow({
                        children: [
                            new TableCell({
                                verticalAlign: VerticalAlignTable.CENTER,
                                width: { size: 55, type: WidthType.PERCENTAGE },
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.LEFT, 
                                        children: [ 
                                            new TextRun({ text: participantes, font: 'Arial', size: 24 })
                                        ]
                                    }) 
                                ] 
                            }),
                            new TableCell({
                                verticalAlign: VerticalAlignTable.CENTER,
                                width: { size: 45, type: WidthType.PERCENTAGE },
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.LEFT, 
                                        children: [ 
                                            new TextRun({ text: modalidad, font: 'Arial', size: 24 })
                                        ]
                                    }) 
                                ] 
                            })
                        ]
                    }),
                    new TableRow({
                        children: [
                            new TableCell({
                                columnSpan: 2,
                                shading: { fill: '#8db3e2' }, 
                                verticalAlign: VerticalAlignTable.CENTER,
                                width: { size: 100, type: WidthType.PERCENTAGE },
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.LEFT, 
                                        children: [ 
                                            new TextRun({ text: `Evidencias mínimas:`, font: 'Arial', size: 24, bold: true })
                                        ]
                                    }) 
                                ] 
                            })
                        ]
                    }),
                    new TableRow({
                        children: [
                            new TableCell({
                                columnSpan: 2,
                                shading: { fill: '#8db3e2' }, 
                                verticalAlign: VerticalAlignTable.CENTER,
                                width: { size: 100, type: WidthType.PERCENTAGE },
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.LEFT, 
                                        children: [ 
                                            new TextRun({ text: `Listas de asistencia o certificaciones de participación`, font: 'Arial', size: 24, bold: true })
                                        ]
                                    }) 
                                ] 
                            })
                        ]
                    }),
                ]
                let rowActividad = this.evidenciasRows(e.docAsistencia, 2)
                rows.push(...rowActividad)
                rows.push(
                    new TableRow({
                        children: [
                            new TableCell({
                                columnSpan: 2,
                                shading: { fill: '#8db3e2' }, 
                                verticalAlign: VerticalAlignTable.CENTER,
                                width: { size: 100, type: WidthType.PERCENTAGE },
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.LEFT, 
                                        children: [ 
                                            new TextRun({ text: `Fotografías de la actividad o del personal recibiendo la capacitación:`, font: 'Arial', size: 24, bold: true })
                                        ]
                                    }) 
                                ] 
                            })
                        ]
                    }),
                )
                let rowAsistencia = this.evidenciasRows(e.docActividad, 2)
                rows.push(...rowAsistencia)
                rows.push(
                    new TableRow({
                        children: [
                            new TableCell({
                                columnSpan: 2,
                                shading: { fill: '#8db3e2' }, 
                                verticalAlign: VerticalAlignTable.CENTER,
                                width: { size: 100, type: WidthType.PERCENTAGE },
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.LEFT, 
                                        children: [ 
                                            new TextRun({ text: `Imágenes (específicas del tema tratado asociado a este parámetro) con el contenido de la presentación utilizada en la capacitación o charla:`, font: 'Arial', size: 24, bold: true })
                                        ]
                                    }) 
                                ] 
                            })
                        ]
                    }),
                )
                let rowEvidencias = this.evidenciasRows(e.docEvidencia, 2)
                rows.push(...rowEvidencias)

                let tableEduc = new Table({
                    width: {
                        size: 100,
                        type: WidthType.PERCENTAGE,
                    },
                    rows: rows
                })
                tables.push(tableEduc)
                tables.push( new Paragraph({ text: "", spacing: { after: 100 } }))
            })
        } else {
            let emptyTableEduc = new Table({
                width: {
                    size: 100,
                    type: WidthType.PERCENTAGE,
                },
                rows: [
                    new TableRow({
                        children: [
                            new TableCell({
                                columnSpan: 2,
                                shading: { fill: '#4bacc6' }, 
                                verticalAlign: VerticalAlignTable.CENTER,
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.LEFT, 
                                        children: [ 
                                            new TextRun({ text: `Actividad N°1:`, font: 'Arial', size: 24 })
                                        ]
                                    }) 
                                ] 
                            })
                        ]
                    }),
                    new TableRow({
                        children: [
                            new TableCell({
                                shading: { fill: '#8db3e2' }, 
                                verticalAlign: VerticalAlignTable.CENTER,
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.LEFT, 
                                        children: [ 
                                            new TextRun({ text: `Nombre de la actividad y del facilitador:`, font: 'Arial', size: 24 })
                                        ]
                                    }) 
                                ] 
                            }),
                            new TableCell({
                                shading: { fill: '#8db3e2' }, 
                                verticalAlign: VerticalAlignTable.CENTER,
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.LEFT, 
                                        children: [ 
                                            new TextRun({ text: `Fecha de la actividad:`, font: 'Arial', size: 24 })
                                        ]
                                    }) 
                                ] 
                            })
                        ]
                    }),
                    new TableRow({
                        height: { value: 600, rule: HeightRule.ATLEAST },
                        children: [
                            new TableCell({
                                verticalAlign: VerticalAlignTable.CENTER,
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.CENTER, 
                                        children: [ 
                                            new TextRun({ text: `N/A`, font: 'Arial', size: 24 })
                                        ]
                                    }) 
                                ] 
                            }),
                            new TableCell({
                                verticalAlign: VerticalAlignTable.CENTER,
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.CENTER, 
                                        children: [ 
                                            new TextRun({ text: `N/A`, font: 'Arial', size: 24 })
                                        ]
                                    }) 
                                ] 
                            })
                        ]
                    }),
                    new TableRow({
                        children: [
                            new TableCell({
                                columnSpan: 2,
                                shading: { fill: '#8db3e2' }, 
                                verticalAlign: VerticalAlignTable.CENTER,
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.LEFT, 
                                        children: [ 
                                            new TextRun({ text: `Descripción y temas tratados:`, font: 'Arial', size: 24 })
                                        ]
                                    }) 
                                ] 
                            })
                        ]
                    }),
                    new TableRow({
                        height: { value: 600, rule: HeightRule.ATLEAST },
                        children: [
                            new TableCell({
                                columnSpan: 2,
                                verticalAlign: VerticalAlignTable.CENTER,
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.CENTER, 
                                        children: [ 
                                            new TextRun({ text: `N/A`, font: 'Arial', size: 24 })
                                        ]
                                    }) 
                                ] 
                            })
                        ]
                    }),
                    new TableRow({
                        children: [
                            new TableCell({
                                shading: { fill: '#8db3e2' }, 
                                verticalAlign: VerticalAlignTable.CENTER,
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.LEFT, 
                                        children: [ 
                                            new TextRun({ text: `Público participante (marque con x):`, font: 'Arial', size: 24 })
                                        ]
                                    }) 
                                ] 
                            }),
                            new TableCell({
                                shading: { fill: '#8db3e2' }, 
                                verticalAlign: VerticalAlignTable.CENTER,
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.LEFT, 
                                        children: [ 
                                            new TextRun({ text: `Modalidad de la actividad (marque con x):`, font: 'Arial', size: 24 })
                                        ]
                                    }) 
                                ] 
                            })
                        ]
                    }),
                    new TableRow({
                        height: { value: 600, rule: HeightRule.ATLEAST },
                        children: [
                            new TableCell({
                                verticalAlign: VerticalAlignTable.CENTER,
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.CENTER, 
                                        children: [ 
                                            new TextRun({ text: `N/A`, font: 'Arial', size: 24 })
                                        ]
                                    }) 
                                ] 
                            }),
                            new TableCell({
                                verticalAlign: VerticalAlignTable.CENTER,
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.CENTER, 
                                        children: [ 
                                            new TextRun({ text: `N/A`, font: 'Arial', size: 24 })
                                        ]
                                    }) 
                                ] 
                            })
                        ]
                    }),
                    new TableRow({
                        children: [
                            new TableCell({
                                columnSpan: 2,
                                shading: { fill: '#8db3e2' }, 
                                verticalAlign: VerticalAlignTable.CENTER,
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.LEFT, 
                                        children: [ 
                                            new TextRun({ text: `Evidencias mínimas:`, font: 'Arial', size: 24, bold: true })
                                        ]
                                    }) 
                                ] 
                            })
                        ]
                    }),
                    new TableRow({
                        children: [
                            new TableCell({
                                columnSpan: 2,
                                shading: { fill: '#8db3e2' }, 
                                verticalAlign: VerticalAlignTable.CENTER,
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.LEFT, 
                                        children: [ 
                                            new TextRun({ text: `Listas de asistencia o certificaciones de participación`, font: 'Arial', size: 24, bold: true })
                                        ]
                                    }) 
                                ] 
                            })
                        ]
                    }),
                    new TableRow({
                        height: { value: 600, rule: HeightRule.ATLEAST },
                        children: [
                            new TableCell({
                                columnSpan: 2,
                                verticalAlign: VerticalAlignTable.CENTER,
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.CENTER, 
                                        children: [ 
                                            new TextRun({ text: `N/A`, font: 'Arial', size: 24 })
                                        ]
                                    }) 
                                ] 
                            })
                        ]
                    }),
                    new TableRow({
                        children: [
                            new TableCell({
                                columnSpan: 2,
                                shading: { fill: '#8db3e2' }, 
                                verticalAlign: VerticalAlignTable.CENTER,
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.LEFT, 
                                        children: [ 
                                            new TextRun({ text: `Fotografías de la actividad`, font: 'Arial', size: 24 })
                                        ]
                                    }) 
                                ] 
                            })
                        ]
                    }),
                    new TableRow({
                        height: { value: 600, rule: HeightRule.ATLEAST },
                        children: [
                            new TableCell({
                                columnSpan: 2,
                                verticalAlign: VerticalAlignTable.CENTER,
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.CENTER, 
                                        children: [ 
                                            new TextRun({ text: `N/A`, font: 'Arial', size: 24 })
                                        ]
                                    }) 
                                ] 
                            })
                        ]
                    }),
                    new TableRow({
                        children: [
                            new TableCell({
                                columnSpan: 2,
                                shading: { fill: '#8db3e2' }, 
                                verticalAlign: VerticalAlignTable.CENTER,
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.LEFT, 
                                        children: [ 
                                            new TextRun({ text: `Imágenes (específicas del tema tratado asociado a este parámetro) con el contenido de la presentación utilizada en la capacitación o charla:`, font: 'Arial', size: 24 })
                                        ]
                                    }) 
                                ] 
                            })
                        ]
                    }),
                    new TableRow({
                        height: { value: 600, rule: HeightRule.ATLEAST },
                        children: [
                            new TableCell({
                                columnSpan: 2,
                                verticalAlign: VerticalAlignTable.CENTER,
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.CENTER, 
                                        children: [ 
                                            new TextRun({ text: `N/A`, font: 'Arial', size: 24 })
                                        ]
                                    }) 
                                ] 
                            })
                        ]
                    }),
                ]
            })
            tables.push(emptyTableEduc)
        }
        return tables
    }

    accionReduccion2025(datos) {
        let tables= []
        if(Array.isArray(datos) && datos.length > 0) {
            datos.forEach(e => {                
                let rows = [
                    new TableRow({
                        children: [
                            new TableCell({
                                shading: { fill: '#8db3e2' }, 
                                verticalAlign: VerticalAlignTable.CENTER,
                                width: { size: 55, type: WidthType.PERCENTAGE },
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.LEFT, 
                                        children: [ 
                                            new TextRun({ text: `Nombre de la acción realizada:`, font: 'Arial', size: 24 })
                                        ]
                                    }) 
                                ] 
                            }),
                            new TableCell({
                                shading: { fill: '#8db3e2' }, 
                                verticalAlign: VerticalAlignTable.CENTER,
                                width: { size: 45, type: WidthType.PERCENTAGE },
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.LEFT, 
                                        children: [ 
                                            new TextRun({ text: `Fecha de la acción:`, font: 'Arial', size: 24 })
                                        ]
                                    }) 
                                ] 
                            })
                        ]
                    }),
                    new TableRow({
                        children: [
                            new TableCell({
                                verticalAlign: VerticalAlignTable.CENTER,
                                width: { size: 55, type: WidthType.PERCENTAGE },
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.LEFT, 
                                        children: [ 
                                            new TextRun({ text: e.tipoActividad, font: 'Arial', size: 24 })
                                        ]
                                    }) 
                                ] 
                            }),
                            new TableCell({
                                verticalAlign: VerticalAlignTable.CENTER,
                                width: { size: 45, type: WidthType.PERCENTAGE },
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.LEFT, 
                                        children: [ 
                                            new TextRun({ text: moment(e.fechaActividad).format("DD/MM/YYYY"), font: 'Arial', size: 24 })
                                        ]
                                    }) 
                                ] 
                            })
                        ]
                    }),
                    new TableRow({
                        children: [
                            new TableCell({
                                columnSpan: 2,
                                shading: { fill: '#8db3e2' }, 
                                verticalAlign: VerticalAlignTable.CENTER,
                                width: { size: 100, type: WidthType.PERCENTAGE },
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.LEFT, 
                                        children: [ 
                                            new TextRun({ text: `Descripción:`, font: 'Arial', size: 24 })
                                        ]
                                    }) 
                                ] 
                            })
                        ]
                    }),
                    new TableRow({
                        children: [
                            new TableCell({
                                columnSpan: 2,
                                verticalAlign: VerticalAlignTable.CENTER,
                                width: { size: 100, type: WidthType.PERCENTAGE },
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.LEFT, 
                                        children: [ 
                                            new TextRun({ text: e.descripcion, font: 'Arial', size: 24 })
                                        ]
                                    }) 
                                ] 
                            })
                        ]
                    }),
                    new TableRow({
                        children: [
                            new TableCell({
                                columnSpan: 2,
                                shading: { fill: '#8db3e2' }, 
                                verticalAlign: VerticalAlignTable.CENTER,
                                width: { size: 100, type: WidthType.PERCENTAGE },
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.LEFT, 
                                        children: [ 
                                            new TextRun({ text: `Evidencias:`, font: 'Arial', size: 24, bold: true })
                                        ]
                                    }) 
                                ] 
                            })
                        ]
                    }),
                    new TableRow({
                        children: [
                            new TableCell({
                                columnSpan: 2,
                                shading: { fill: '#8db3e2' }, 
                                width: { size: 100, type: WidthType.PERCENTAGE },
                                verticalAlign: VerticalAlignTable.CENTER,
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.LEFT, 
                                        children: [ 
                                            new TextRun({ text: `Fotografías de las acciones:`, font: 'Arial', size: 24, bold: true })
                                        ]
                                    }) 
                                ] 
                            })
                        ]
                    }),
                ]
                let rowActividad = this.evidenciasRows(e.docEvidenciaR, 2)
                rows.push(...rowActividad)
                
                let tableEduc = new Table({
                    width: {
                        size: 100,
                        type: WidthType.PERCENTAGE,
                    },
                    rows: rows
                })
                tables.push(tableEduc)
                tables.push( new Paragraph({ text: "", spacing: { after: 100 } }))
            })
        } else {
            let emptyTableEduc = new Table({
                width: {
                    size: 100,
                    type: WidthType.PERCENTAGE,
                },
                rows: [
                    new TableRow({
                        children: [
                            new TableCell({
                                shading: { fill: '#8db3e2' }, 
                                verticalAlign: VerticalAlignTable.CENTER,
                                width: { size: 55, type: WidthType.PERCENTAGE },
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.LEFT, 
                                        children: [ 
                                            new TextRun({ text: `Nombre de la acción realizada:`, font: 'Arial', size: 24 })
                                        ]
                                    }) 
                                ] 
                            }),
                            new TableCell({
                                shading: { fill: '#8db3e2' }, 
                                verticalAlign: VerticalAlignTable.CENTER,
                                width: { size: 45, type: WidthType.PERCENTAGE },
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.LEFT, 
                                        children: [ 
                                            new TextRun({ text: `Fecha de la acción:`, font: 'Arial', size: 24 })
                                        ]
                                    }) 
                                ] 
                            })
                        ]
                    }),
                    new TableRow({
                        height: { value: 600, rule: HeightRule.ATLEAST },
                        children: [
                            new TableCell({
                                verticalAlign: VerticalAlignTable.CENTER,
                                width: { size: 55, type: WidthType.PERCENTAGE },
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.CENTER, 
                                        children: [ 
                                            new TextRun({ text: `N/A`, font: 'Arial', size: 24 })
                                        ]
                                    }) 
                                ] 
                            }),
                            new TableCell({
                                verticalAlign: VerticalAlignTable.CENTER,
                                width: { size: 45, type: WidthType.PERCENTAGE },
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.CENTER, 
                                        children: [ 
                                            new TextRun({ text: `N/A`, font: 'Arial', size: 24 })
                                        ]
                                    }) 
                                ] 
                            })
                        ]
                    }),
                    new TableRow({
                        children: [
                            new TableCell({
                                columnSpan: 2,
                                shading: { fill: '#8db3e2' }, 
                                verticalAlign: VerticalAlignTable.CENTER,
                                width: { size: 100, type: WidthType.PERCENTAGE },
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.LEFT, 
                                        children: [ 
                                            new TextRun({ text: `Descripción:`, font: 'Arial', size: 24 })
                                        ]
                                    }) 
                                ] 
                            })
                        ]
                    }),
                    new TableRow({
                        height: { value: 600, rule: HeightRule.ATLEAST },
                        children: [
                            new TableCell({
                                columnSpan: 2,
                                verticalAlign: VerticalAlignTable.CENTER,
                                width: { size: 100, type: WidthType.PERCENTAGE },
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.CENTER, 
                                        children: [ 
                                            new TextRun({ text: `N/A`, font: 'Arial', size: 24 })
                                        ]
                                    }) 
                                ] 
                            })
                        ]
                    }),
                    new TableRow({
                        children: [
                            new TableCell({
                                columnSpan: 2,
                                shading: { fill: '#8db3e2' }, 
                                verticalAlign: VerticalAlignTable.CENTER,
                                width: { size: 100, type: WidthType.PERCENTAGE },
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.LEFT, 
                                        children: [ 
                                            new TextRun({ text: `Evidencias:`, font: 'Arial', size: 24, bold: true })
                                        ]
                                    }) 
                                ] 
                            })
                        ]
                    }),
                    new TableRow({
                        children: [
                            new TableCell({
                                columnSpan: 2,
                                shading: { fill: '#8db3e2' }, 
                                verticalAlign: VerticalAlignTable.CENTER,
                                width: { size: 100, type: WidthType.PERCENTAGE },
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.LEFT, 
                                        children: [ 
                                            new TextRun({ text: `Fotografías de las acciones:`, font: 'Arial', size: 24 })
                                        ]
                                    }) 
                                ] 
                            })
                        ]
                    }),
                    new TableRow({
                        height: { value: 600, rule: HeightRule.ATLEAST },
                        children: [
                            new TableCell({
                                columnSpan: 2,
                                verticalAlign: VerticalAlignTable.CENTER,
                                width: { size: 100, type: WidthType.PERCENTAGE },
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.CENTER, 
                                        children: [ 
                                            new TextRun({ text: `N/A`, font: 'Arial', size: 24 })
                                        ]
                                    }) 
                                ] 
                            })
                        ]
                    })
                ]
            })
            tables.push(emptyTableEduc)
        }
        return tables
    }

    tituloConEvidencias(titulo, evidencias, color, tipoDocumento) {
        let evidenciasRows;
        let docs;
        
        if(tipoDocumento != null) {
            if(Array.isArray(tipoDocumento)) {
                docs = evidencias.filter(obj => tipoDocumento.includes(obj.idTipoDocumento)).map(obj => obj.evidencia);
            } else {
                docs = evidencias.filter(obj => obj.idTipoDocumento === tipoDocumento).map(obj => obj.evidencia);
            }
            evidenciasRows = this.evidenciasRows(docs, 1)
        } else {
            evidenciasRows = this.evidenciasRows(evidencias, 1)
        }
        let rows = [
            new TableRow({
                children: [
                    new TableCell({
                        shading: { fill: color }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({ 
                                alignment: AlignmentType.LEFT, 
                                children: [ 
                                    new TextRun({ text: titulo, font: 'Arial', size: 24 })
                                ]
                            }) 
                        ] 
                    }),
                ]
            })
        ]
        rows.push(...evidenciasRows)
        let tableEvid = new Table({
            width: {
                size: 100,
                type: WidthType.PERCENTAGE,
            },
            rows: rows
        })
        return tableEvid
    }

    evidenciasRows(evidencias, columnSpan) {
        let rows = []
        if(Array.isArray(evidencias)) {
            if(evidencias.length > 0) {
                evidencias.forEach(d => {
                    let row = new TableRow({
                        children: [
                            new TableCell( { 
                                columnSpan: columnSpan, 
                                width: { size: 100, type: WidthType.PERCENTAGE }, 
                                children: [ 
                                    new Paragraph({
                                        alignment: AlignmentType.CENTER,
                                        children: [
                                            this.generateImageRun(d, 500, 300)
                                        ],
                                    })
                                ] 
                            } ),
                        ]
                    })
                    rows.push(row)
                })
            } else {
                let emptyRow = new TableRow({
                    children: [
                        new TableCell( { 
                            columnSpan: columnSpan, 
                            width: { size: 100, type: WidthType.PERCENTAGE }, 
                            children: [ 
                                new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                        new TextRun({ text: `N/A`, font: 'Arial', size: 24 })
                                    ],
                                })
                            ] 
                        } ),
                    ]
                })
                rows.push(emptyRow)
            }
        } else {
            if(evidencias != undefined && evidencias != null && evidencias.length > 0) {
                let singleRow = new TableRow({
                    children: [
                        new TableCell( { 
                            columnSpan: columnSpan, 
                            width: { size: 100, type: WidthType.PERCENTAGE }, 
                            children: [ 
                                new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                        this.generateImageRun(evidencias, 500, 300)
                                    ],
                                })
                            ] 
                        } ),
                    ]
                })
                rows.push(singleRow)
            } else {
                let singleEmptyRow = new TableRow({
                    height: { value: 1000, rule: HeightRule.ATLEAST },
                    children: [
                        new TableCell( { 
                            columnSpan: columnSpan, 
                            width: { size: 100, type: WidthType.PERCENTAGE }, 
                            children: [ 
                                new Paragraph({
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                        new TextRun({ text: `N/A`, font: 'Arial', size: 24 })
                                    ],
                                })
                            ] 
                        } ),
                    ]
                })
                rows.push(singleEmptyRow)
            }
        }
        return rows
    }

    evidenciasTipoRows(evidencias, columnSpan, tipoDocumento) {
        let docs;
        let evidenciasRows;
        if(tipoDocumento != null) {
            if(Array.isArray(tipoDocumento)) {
                docs = evidencias.filter(obj => tipoDocumento.includes(obj.idTipoDocumento)).map(obj => obj.evidencia);
            } else {
                docs = evidencias.filter(obj => obj.idTipoDocumento === tipoDocumento).map(obj => obj.evidencia);
            }
            evidenciasRows = this.evidenciasRows(docs, columnSpan)
        } else {
            evidenciasRows = this.evidenciasRows(evidencias, columnSpan)
        }
        return evidenciasRows;
    }

    detalleTipoStar(sist) {
        let detalle = '4.1.1 Planta de tratamiento de aguas residuales'
        if (sist != undefined && sist != null && sist.sistema > 0) {
            switch(sist.sistema) {
                case this.constantes.PLANTA_TRATAMIENTO:
                    detalle = '4.1.1 Planta de tratamiento de aguas residuales'
                    break;
                case this.constantes.TANQUE_SEPTICO:
                    detalle = '4.1.2. Tanques sépticos y drenajes'
                    break;
                case this.constantes.ALCANTARILLADO_SANITARIO:
                    detalle = '4.1.3. Alcantarillado Sanitario'
                    break;
            }
        }

        return  new Paragraph({
            alignment: AlignmentType.LEFT,
            spacing: { after: 150 },
            children: [ new TextRun( { text: detalle, font: 'Arial', size: 24, bold: true } ) ],
        })
    }

    identificarStar2025(sist) {
        let starData = []
        if (sist != undefined && sist != null && sist.sistema > 0) {
            let tiposDoc = []
            switch(sist.sistema) {
                case this.constantes.PLANTA_TRATAMIENTO:
                    tiposDoc = [this.constantes.PERMISO_VERTIDO, this.constantes.COMPROBANTE_PAGO, this.constantes.REPORTE_DATOS, this.constantes.REPORTE_OPERACIONAL]
                    starData.push(this.tituloConEvidencias('Croquis de la ubicación de la planta de tratamiento donde se depositan las aguas residuales de la sede participante:', sist.croquis, '#8db3e2', null))
                    starData.push(this.tituloConEvidencias('Documento de: Permiso vertido de las aguas residuales, reporte operacional, Reporte de datos de manejo integral de lodos y biosólidos, o Comprobante de pago del canon', sist.evidencias, '#8db3e2', tiposDoc))
                    break;
                case this.constantes.TANQUE_SEPTICO:
                    tiposDoc = [this.constantes.PERMISO_PROVEEDOR, this.constantes.PERMISO_SANITARIO_PROV, this.constantes.CONSTANCIA_PROVEEDOR]
                    starData.push(this.justificacionConEvidenciasDto('Diagnóstico y plan de mantenimiento:', sist.diagnostico, sist.evidencias, '#8db3e2', this.constantes.DIAGNOSTICO_PLAN_SIST))
                    starData.push(this.tituloConEvidencias('Croquis de la ubicación del tanque séptico y el drenaje:', sist.croquis, '#8db3e2', null))
                    starData.push(this.tituloDobleConEvidencias('Si realizaron limpiezas de lodos en el año de participación:', 'Documento: Permiso de funcionamiento del proveedor que realizó limpieza, Permiso sanitario de funcionamiento del proveedor que realizó tratamiento o disposición final de los lodos o Constancia del proveedor que trató los lodos, declarando que el proveedor de limpieza entregó lodos provenientes de la organización participante:', sist.evidencias, '#8db3e2', tiposDoc))
                    break;
                case this.constantes.ALCANTARILLADO_SANITARIO:
                    tiposDoc = [this.constantes.CONSTANCIA_DESCARGA, this.constantes.CONSTANCIA_TRAT_AGUA]
                    starData.push(this.tituloConEvidencias('Documento que permita comprobar la descarga de la sede participante al sistema de alcantarillado sanitario', sist.evidencias, '#8db3e2', tiposDoc))
                    break;
            }
            starData.push(new Paragraph({ text: "", spacing: { after: 100 } }))//espacio en blanco
            starData.push(this.justificacionConEvidenciasDto('Justificación en caso de que el documento no esté a nombre de la sede o ausencia de datos (información) y evidencias de la gestión realizada para obtener lo solicitado:', sist.justificacionNoDatos, sist.evidencias, '#8db3e2', this.constantes.JUSTIF_SISTEMA_TRATAMIENTO))
        } else {
            if(sist != null && sist.justificacionDosAnio != null) {
				starData.push(this.justificacionConEvidenciasDto('Justificación en caso de ausencia de datos (información) y evidencias de la gestión realizada para obtener lo solicitado:', sist.justificacionDosAnio, sist.evidencias, '#8db3e2', this.constantes.JUSTIF_IDENT_SIST_TRATAMIENTO))
			} else {
				starData.push(
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 150 },
                        children: [ 
                            new TextRun( { text: 'Atención:', font: 'Arial', size: 24, color: '#FF0000', bold: true } ), 
                            new TextRun( { break: 1 } ),
                            new TextRun( { text: 'Sistema de Tratamiento de Aguas Residuales NO identificado en la aplicación. Debe identificar el STAR o agregar una justificación.', font: 'Arial', size: 24, color: '#FF0000', bold: true } ), 
                        ],
                    })
                )
			}
        }
        return starData
    }

    justificacionConEvidenciasDto(titulo, justificacion, evidencias, rowColor, tipoDocumento) {
        let rows = []
        let evidenciasRows = []
        let docs = []
        let rowTitulo = new TableRow({
            children: [
                new TableCell({
                    shading: { fill: rowColor }, 
                    verticalAlign: VerticalAlignTable.CENTER,
                    children: [ 
                        new Paragraph({ 
                            alignment: AlignmentType.LEFT, 
                            children: [ new TextRun({ text: `${this.blankData(titulo)}`, font: 'Arial', size: 24 }) ] 
                        }) 
                    ]
                })
            ]
        });
        rows.push(rowTitulo)
        let rowJustificacion = new TableRow({
            children: [
                new TableCell({
                    verticalAlign: VerticalAlignTable.CENTER,
                    children: [ 
                        new Paragraph({ 
                            alignment: AlignmentType.LEFT, 
                            children: [ new TextRun({ text: `${this.blankData(justificacion)}`, font: 'Arial', size: 24 }) ] 
                        }) 
                    ]
                })
            ]
        });
        rows.push(rowJustificacion)

        if(tipoDocumento != null) {
            if(Array.isArray(tipoDocumento)) {
                docs = evidencias.filter(obj => tiposDocumento.includes(obj.idTipoDocumento)).map(obj => obj.evidencia);
            } else {
                docs = evidencias.filter(obj => obj.idTipoDocumento === tipoDocumento).map(obj => obj.evidencia);
            }
            evidenciasRows = this.evidenciasRows(docs, 1)
        } else {
            evidenciasRows = this.evidenciasRows(evidencias, 1)
        }

        rows.push(...evidenciasRows)
        
        let justifTable = new Table({
            width: {
                size: 100,
                type: WidthType.PERCENTAGE,
            },
            rows: rows
        })
        return justifTable;
    }

    disposicionResiduos(residuos) {
        let rows = []
        let rowTitulo = new TableRow({
            children: [
                new TableCell({
                    shading: { fill: '#92cddc' }, 
                    columnSpan: 8,
                    verticalAlign: VerticalAlignTable.CENTER,
                    children: [ 
                        new Paragraph({ 
                            alignment: AlignmentType.LEFT, 
                            children: [ new TextRun({ text: `En caso de generar residuos orgánicos, indique la disposición final de estos (marque con X)`, font: 'Arial', size: 24 }) ] 
                        }) 
                    ]
                })
            ]
        });
        rows.push(rowTitulo)
        let rowDisposicionUno = new TableRow({
            children: [
                new TableCell({
                    verticalAlign: VerticalAlignTable.CENTER,
                    children: [ 
                        new Paragraph({ 
                            alignment: AlignmentType.LEFT, 
                            children: [ new TextRun({ text: `Biodigestores:`, font: 'Arial', size: 24 }) ] 
                        }) 
                    ]
                }),
                new TableCell({
                    verticalAlign: VerticalAlignTable.CENTER,
                    children: [ 
                        new Paragraph({ 
                            alignment: AlignmentType.CENTER, 
                            children: [ new TextRun({ text: `${this.tipoDisposicion(residuos, 'Biodigestores')}`, font: 'Arial', size: 24 }) ] 
                        }) 
                    ]
                }),
                new TableCell({
                    verticalAlign: VerticalAlignTable.CENTER,
                    children: [ 
                        new Paragraph({ 
                            alignment: AlignmentType.LEFT, 
                            children: [ new TextRun({ text: `Compost:`, font: 'Arial', size: 24 }) ] 
                        }) 
                    ]
                }),
                new TableCell({
                    verticalAlign: VerticalAlignTable.CENTER,
                    children: [ 
                        new Paragraph({ 
                            alignment: AlignmentType.CENTER, 
                            children: [ new TextRun({ text: `${this.tipoDisposicion(residuos, 'Compost')}`, font: 'Arial', size: 24 }) ] 
                        }) 
                    ]
                }),
                new TableCell({
                    verticalAlign: VerticalAlignTable.CENTER,
                    children: [ 
                        new Paragraph({ 
                            alignment: AlignmentType.LEFT, 
                            children: [ new TextRun({ text: `Recolector privado:`, font: 'Arial', size: 24 }) ] 
                        }) 
                    ]
                }),
                new TableCell({
                    verticalAlign: VerticalAlignTable.CENTER,
                    children: [ 
                        new Paragraph({ 
                            alignment: AlignmentType.CENTER, 
                            children: [ new TextRun({ text: `${this.tipoDisposicion(residuos, 'Recolector privado')}`, font: 'Arial', size: 24 }) ] 
                        }) 
                    ]
                }),
                new TableCell({
                    verticalAlign: VerticalAlignTable.CENTER,
                    children: [ 
                        new Paragraph({ 
                            alignment: AlignmentType.LEFT, 
                            children: [ new TextRun({ text: `Recolector público:`, font: 'Arial', size: 24 }) ] 
                        }) 
                    ]
                }),
                new TableCell({
                    verticalAlign: VerticalAlignTable.CENTER,
                    children: [ 
                        new Paragraph({ 
                            alignment: AlignmentType.CENTER, 
                            children: [ new TextRun({ text: `${this.tipoDisposicion(residuos, 'Recolector público')}`, font: 'Arial', size: 24 }) ] 
                        }) 
                    ]
                })
            ]
        });
        rows.push(rowDisposicionUno)
        let rowDisposicionDos = new TableRow({
            children: [
                new TableCell({
                    columnSpan: 2,
                    verticalAlign: VerticalAlignTable.CENTER,
                    children: [ 
                        new Paragraph({ 
                            alignment: AlignmentType.LEFT, 
                            children: [ new TextRun({ text: `Otro:`, font: 'Arial', size: 24 }) ] 
                        }) 
                    ]
                }),
                new TableCell({
                    verticalAlign: VerticalAlignTable.CENTER,
                    children: [ 
                        new Paragraph({ 
                            alignment: AlignmentType.LEFT, 
                            children: [ new TextRun({ text: `${this.tipoDisposicion(residuos, 'Otro')}`, font: 'Arial', size: 24 }) ] 
                        }) 
                    ]
                }),
                new TableCell({
                    columnSpan: 2,
                    verticalAlign: VerticalAlignTable.CENTER,
                    children: [ 
                        new Paragraph({ 
                            alignment: AlignmentType.LEFT, 
                            children: [ new TextRun({ text: `Nombre gestor:`, font: 'Arial', size: 24 }) ] 
                        }) 
                    ]
                }),
                new TableCell({
                    columnSpan: 3,
                    verticalAlign: VerticalAlignTable.CENTER,
                    children: [ 
                        new Paragraph({ 
                            alignment: AlignmentType.LEFT, 
                            children: [ new TextRun({ text: `${this.gestorOrganicos(residuos)}`, font: 'Arial', size: 24 }) ] 
                        }) 
                    ]
                })
            ]
        });
        rows.push(rowDisposicionDos)
        
        let dispoTable = new Table({
            width: {
                size: 100,
                type: WidthType.PERCENTAGE,
            },
            rows: rows
        })
        return dispoTable;
    }

    tipoDisposicion(residuos, tipo) {
        let blank = '___________'
        residuos.forEach(r => {
            let nombreLower = r.nombre != null ? r.nombre.toLowerCase() : "";
            let isOrganico = (nombreLower === "orgánicos" || nombreLower === "orgánico" || nombreLower === "organicos" || nombreLower === "organico")
            if(isOrganico) {
                if(r.disposicion === tipo) {
                    blank = 'X';
                }
            }
        })
        return blank;
    }

    gestorOrganicos(residuos) {
        let blank = '___________________________________________'
        residuos.forEach(r => {
            let nombreLower = r.nombre != null ? r.nombre.toLowerCase() : "";
            let isOrganico = (nombreLower === "orgánicos" || nombreLower === "orgánico" || nombreLower === "organicos" || nombreLower === "organico")
            if(isOrganico) {
                blank = r.gestor;
            }
        })
        return blank;
    }

    trazabilidadResEspeciales(datos) {
        let rows = []
        let rowTitulo = new TableRow({
            children: [
                new TableCell({
                    shading: { fill: '#92cddc' }, 
                    width: { size: 20, type: WidthType.PERCENTAGE },
                    verticalAlign: VerticalAlignTable.CENTER,
                    children: [ 
                        new Paragraph({ 
                            alignment: AlignmentType.CENTER, 
                            children: [ new TextRun({ text: `Nombre del residuo`, font: 'Arial', size: 24 }) ] 
                        }) 
                    ]
                }),
                new TableCell({
                    shading: { fill: '#92cddc' }, 
                    width: { size: 80, type: WidthType.PERCENTAGE },
                    verticalAlign: VerticalAlignTable.CENTER,
                    children: [ 
                        new Paragraph({ 
                            alignment: AlignmentType.CENTER, 
                            children: [ new TextRun({ text: `Descripción de la trazabilidad del residuo`, font: 'Arial', size: 24 }) ] 
                        }) 
                    ]
                })
            ]
        });
        rows.push(rowTitulo)
        if(datos != null && datos != undefined && datos.length) {
            datos.forEach(r => {
                let dataRow = new TableRow({
                    children: [
                        new TableCell({ 
                            width: { size: 20, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.blankData(r.nombreResiduo), font: 'Arial', size: 24 }) ], }) ] 
                        }),
                        new TableCell({ 
                            width: { size: 80, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.LEFT, children: [ new TextRun({ text: this.blankData(r.descripcionTrazabilidad), font: 'Arial', size: 24 }) ], }) ] 
                        })
                    ]
                })
                rows.push(dataRow)
            })
        } else {
            let emptyRow = this.emptyTableRow(2)
            rows.push(emptyRow)
        }

        let trazabilidadTable = new Table({
            width: {
                size: 100,
                type: WidthType.PERCENTAGE,
            },
            rows: rows
        })
        return trazabilidadTable;
    }

    tablaEvidenciasResEspec(datos) {
        let rows = []
        let rowTitulo = new TableRow({
            children: [
                new TableCell({
                    shading: { fill: '#92cddc' }, 
                    columnSpan: 8,
                    verticalAlign: VerticalAlignTable.CENTER,
                    children: [ 
                        new Paragraph({ 
                            alignment: AlignmentType.LEFT, 
                            children: [ new TextRun({ text: 'En caso de haber generado este tipo de residuo: Copia del certificado del gestor autorizado o registros internos de la sede', font: 'Arial', size: 24 }) ] 
                        }) 
                    ]
                })
            ]
        });
        rows.push(rowTitulo)
        
        if(datos != null && datos != undefined && datos.length) {
            datos.forEach((r, index) => {
                let count = index + 1;
                let dataRow = new TableRow({
                    children: [
                        new TableCell({ 
                            shading: { fill: '#92cddc' }, 
                            width: { size: 100, type: WidthType.PERCENTAGE }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.LEFT, children: [ new TextRun({ text: `Residuo ${count}: ${this.blankData(r.residuo)}`, font: 'Arial', size: 24 }) ], }) ] 
                        })
                    ]
                })
                rows.push(dataRow)
                let evidencias = r.evidencias.map(e => e.evidencia);
                let rowaEvidencias = this.evidenciasRows(evidencias, 1)
                rows.push(...rowaEvidencias)
            })
        } else {
            let emptyRow = this.emptyTableRow(1)
            rows.push(emptyRow)
        }

        let resEspecialesTable = new Table({
            width: {
                size: 100,
                type: WidthType.PERCENTAGE,
            },
            rows: rows
        })
        return resEspecialesTable;
    }

    inventGasesTitutlo(sinEquipos) {
        let paragraph;
        if(sinEquipos) {
            paragraph = new Paragraph({
                alignment: AlignmentType.CENTER,
                spacing: { after: 250, before:100 },
                children: [ new TextRun( { text: "Cuadro N°33-b", font: 'Arial', size: 28, color: '#365F91' } ),
                            new TextRun({ break: 1 }), 
                            new TextRun( { text: `Educación Ambiental o Acción de Reducción y control`, font: 'Arial', size: 28, color: '#365F91' } ),
                            new TextRun({ break: 1 }),
                            new TextRun( { text: `(Actividad que sustituye el inventario de equipo, en caso de no tener equipos que consumen gases refrigerantes)`, font: 'Arial', size: 22, color: '#365F91' } ),
                    ],
            })
        } else {
            paragraph = new Paragraph({
                alignment: AlignmentType.CENTER,
                spacing: { after: 250, before:100 },
                children: [ new TextRun( { text: "Cuadro N°33-a", font: 'Arial', size: 28, color: '#365F91' } ),
                            new TextRun({ break: 1 }), 
                            new TextRun( { text: `Inventarios de equipos que consumen gases refrigerantes`, font: 'Arial', size: 28, color: '#365F91' } )
                    ],
            })
        }
        return paragraph
    }

    inventGases(inventario, sinEquipos, educacion, acciones) {
        if(sinEquipos) {
            let children = []
            let educaciones = this.educacionAmbiental2025(educacion)
            children.push(...educaciones)
            children.push(new Paragraph({ text: "", spacing: { after: 100 } }))
            let accionRed = this.accionReduccion2025(acciones)
            children.push(...accionRed)
            return children
        } else {
            let rows = []
            let rowTitulo = new TableRow({
                children: [
                    new TableCell({
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({ 
                                alignment: AlignmentType.CENTER, 
                                children: [ new TextRun({ text: `Equipo que consume gas refrigerante`, font: 'Arial', size: 24 }) ] 
                            }) 
                        ]
                    }),
                    new TableCell({
                        shading: { fill: '#92cddc' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({ 
                                alignment: AlignmentType.CENTER, 
                                children: [ new TextRun({ text: `Gas refrigerante que consume`, font: 'Arial', size: 24 }) ] 
                            }) 
                        ]
                    })
                ]
            });
            rows.push(rowTitulo)
            if(inventario != null && inventario != undefined && inventario.length) {
                inventario.forEach(r => {
                    let dataRow = new TableRow({
                        children: [
                            new TableCell({ 
                                verticalAlign: VerticalAlignTable.CENTER,
                                children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.blankData(r.producto), font: 'Arial', size: 24 }) ], }) ] 
                            }),
                            new TableCell({ 
                                verticalAlign: VerticalAlignTable.CENTER,
                                children: [ new Paragraph({ alignment: AlignmentType.LEFT, children: [ new TextRun({ text: this.blankData(r.tipoContaminanteNombre), font: 'Arial', size: 24 }) ], }) ] 
                            })
                        ]
                    })
                    rows.push(dataRow)
                })
            } else {
                let emptyRow = this.emptyTableRow(2)
                rows.push(emptyRow)
            }

            let inventarioTable = new Table({
                width: {
                    size: 100,
                    type: WidthType.PERCENTAGE,
                },
                rows: rows
            })
            return [ inventarioTable ];
        }
    }

    productoSostTitulo(sinProductos) {
        let paragraph;
        if(sinProductos) {
            paragraph = new Paragraph({
                alignment: AlignmentType.CENTER,
                spacing: { after: 250, before:100 },
                children: [ new TextRun( { text: "Cuadro N°36-b", font: 'Arial', size: 28, color: '#365F91' } ),
                            new TextRun({ break: 1 }), 
                            new TextRun( { text: `Educación Ambiental o Acción de Reducción y control`, font: 'Arial', size: 28, color: '#365F91' } ),
                            new TextRun({ break: 1 }),
                            new TextRun( { text: `(Actividad para sedes que no adquirieron productos aplicando criterios de compras sostenibles)`, font: 'Arial', size: 22, color: '#365F91' } ),
                    ],
            })
        } else {
            paragraph = new Paragraph({
                alignment: AlignmentType.CENTER,
                spacing: { after: 250, before:100 },
                children: [ new TextRun( { text: "Cuadro N°36-a", font: 'Arial', size: 28, color: '#365F91' } ),
                            new TextRun({ break: 1 }), 
                            new TextRun( { text: `Productos adquiridos aplicando los criterios de compras sostenibles`, font: 'Arial', size: 28, color: '#365F91' } )
                    ],
            })
        }
        return paragraph
    }

    inventProdSostenibles(sinProductos, inventario, educacion, acciones) {
        if(sinProductos) {
            let children = []
            let educaciones = this.educacionAmbiental2025(educacion)
            children.push(...educaciones)
            children.push(new Paragraph({ text: "", spacing: { after: 100 } }))
            let accionRed = this.accionReduccion2025(acciones)
            children.push(...accionRed)
            return children
        } else {
            let rows = []
            let rowTitulo = new TableRow({
                children: [
                    new TableCell({
                        shading: { fill: '#8db3e2' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        width: { size: 6, type: WidthType.PERCENTAGE }, 
                        children: [ 
                            new Paragraph({ 
                                alignment: AlignmentType.CENTER, 
                                children: [ new TextRun({ text: `N°`, font: 'Arial', size: 24 }) ] 
                            }) 
                        ]
                    }),
                    new TableCell({
                        shading: { fill: '#8db3e2' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        width: { size: 27, type: WidthType.PERCENTAGE },
                        children: [ 
                            new Paragraph({ 
                                alignment: AlignmentType.CENTER, 
                                children: [ new TextRun({ text: `Producto`, font: 'Arial', size: 24 }) ] 
                            }) 
                        ]
                    }),
                    new TableCell({
                        shading: { fill: '#8db3e2' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        width: { size: 27, type: WidthType.PERCENTAGE },
                        children: [ 
                            new Paragraph({ 
                                alignment: AlignmentType.CENTER, 
                                children: [ new TextRun({ text: `Uso`, font: 'Arial', size: 24 }) ] 
                            }) 
                        ]
                    }),
                    new TableCell({
                        shading: { fill: '#8db3e2' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        width: { size: 40, type: WidthType.PERCENTAGE },
                        children: [ 
                            new Paragraph({ 
                                alignment: AlignmentType.CENTER, 
                                children: [ 
                                    new TextRun({ text: `Beneficio ambiental/social`, font: 'Arial', size: 24 }),
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: `identificado al usar este producto`, font: 'Arial', size: 24 })
                                ] 
                            }) 
                        ]
                    })
                ]
            });
            rows.push(rowTitulo)
            if(inventario != null && inventario != undefined && inventario.length) {
                inventario.forEach((p, index) => {
                    let count = index + 1;
                    let dataRow = new TableRow({
                        children: [
                            new TableCell({ 
                                shading: { fill: '#8db3e2' }, 
                                width: { size: 13, type: WidthType.PERCENTAGE }, 
                                verticalAlign: VerticalAlignTable.CENTER,
                                children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: `${count}`, font: 'Arial', size: 24 }) ], }) ] 
                            }),
                            new TableCell({ 
                                width: { size: 13, type: WidthType.PERCENTAGE }, 
                                verticalAlign: VerticalAlignTable.CENTER,
                                children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: this.blankData(p.nombre), font: 'Arial', size: 24 }) ], }) ] 
                            }),
                            new TableCell({ 
                                width: { size: 6, type: WidthType.PERCENTAGE }, 
                                verticalAlign: VerticalAlignTable.CENTER,
                                children: [ new Paragraph({ alignment: AlignmentType.LEFT, children: [ new TextRun({ text: this.blankData(p.uso), font: 'Arial', size: 24 }) ], }) ] 
                            }),
                            new TableCell({ 
                                width: { size: 6, type: WidthType.PERCENTAGE }, 
                                verticalAlign: VerticalAlignTable.CENTER,
                                children: [ new Paragraph({ alignment: AlignmentType.LEFT, children: [ new TextRun({ text: this.blankData(p.criterio), font: 'Arial', size: 24 }) ], }) ] 
                            })
                        ]
                    })
                    rows.push(dataRow)
                })
            } else {
                let emptyRow = this.emptyTableRow(2)
                rows.push(emptyRow)
            }

            let inventarioTable = new Table({
                width: {
                    size: 100,
                    type: WidthType.PERCENTAGE,
                },
                rows: rows
            })

            let evideciasTable = this.evidComprasSost(inventario)
            let newLine = new Paragraph({ text: "", spacing: { after: 100 } })

            return [ inventarioTable, newLine, evideciasTable ];
        }
    }

    evidComprasSost(inventario) {
        if(inventario != null && inventario != undefined && inventario.length) {
            let rows = []
            inventario.forEach((p, index) => {
                let count = index + 1; 
                let rowTituloUno = new TableRow({
                    children: [
                        new TableCell({
                            shading: { fill: '#8db3e2' }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.LEFT, 
                                    children: [ 
                                        new TextRun({ text: `Producto ${count} `, font: 'Arial', size: 24, bold: true }),
                                        new TextRun({ text: this.blankData(p.nombre), font: 'Arial', size: 24, bold: true }) 
                                    ] 
                                }) 
                            ]
                        }),
                    ]
                });
                let rowTituloDos = new TableRow({
                    children: [
                        new TableCell({
                            shading: { fill: '#8db3e2' }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.LEFT, 
                                    children: [ 
                                        new TextRun({ text: `Ficha o documento técnico del proveedor sobre el beneficio ambiental del servicio o producto`, font: 'Arial', size: 24 })
                                    ] 
                                }) 
                            ]
                        }),
                    ]
                });
                rows.push(rowTituloUno)
                rows.push(rowTituloDos)

                let evidUnoRows = this.evidenciasTipoRows(p.evidencias, 1, this.constantes.EVIDENCIA)
                rows.push(...evidUnoRows)

                let rowTituloTres = new TableRow({
                    children: [
                        new TableCell({
                            shading: { fill: '#8db3e2' }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.LEFT, 
                                    children: [ 
                                        new TextRun({ text: `Evidencia del uso o implementación del nuevo producto adquirido`, font: 'Arial', size: 24 })
                                    ] 
                                }) 
                            ]
                        }),
                    ]
                });
                rows.push(rowTituloTres)

                let evidDosRows = this.evidenciasTipoRows(p.evidencias, 1, this.constantes.EVIDENCIA_USO_PRODUCTO)
                rows.push(...evidDosRows)  
            })

            let evidenciasTable = new Table({
                width: {
                    size: 100,
                    type: WidthType.PERCENTAGE,
                },
                rows: rows
            })

            return evidenciasTable;
        } else {
            let emptyTable = new Table({
                width: {
                    size: 100,
                    type: WidthType.PERCENTAGE,
                },
                rows: [
                    new TableRow({
                    children: [
                        new TableCell({
                            shading: { fill: '#8db3e2' }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.LEFT, 
                                    children: [ 
                                        new TextRun({ text: `Producto ${count}`, font: 'Arial', size: 24, bold: true }),
                                        new TextRun({ text: this.blankData(p.nombre), font: 'Arial', size: 24, bold: true }) 
                                    ] 
                                }) 
                            ]
                        }),
                        new TableCell({
                            shading: { fill: '#8db3e2' }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.LEFT, 
                                    children: [ new TextRun({ text: `Ficha o documento técnico del proveedor sobre el beneficio ambiental del servicio o producto`, font: 'Arial', size: 24 }) ] 
                                }) 
                            ]
                        }),
                        new TableCell({
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: `N/A`, font: 'Arial', size: 24 }) ] }) ]
                        }),
                        new TableCell({
                            shading: { fill: '#8db3e2' }, 
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.LEFT, 
                                    children: [ new TextRun({ text: `Evidencia del uso o implementación del nuevo producto adquirido`, font: 'Arial', size: 24 }) ] 
                                }) 
                            ]
                        }),
                        new TableCell({
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: `N/A`, font: 'Arial', size: 24 }) ] }) ]
                        }),
                    ]
                }),
                ]
            })

            return emptyTable;
        }
        
    }

    amenazaClimatica(data) {
        let rows = []
        let titulo = new TableRow({
            children: [
                new TableCell({
                    shading: { fill: '#8db3e2' }, 
                    verticalAlign: VerticalAlignTable.CENTER,
                    children: [ 
                        new Paragraph({ 
                            alignment: AlignmentType.CENTER, 
                            children: [ 
                                new TextRun({ text: `Amenaza climática`, font: 'Arial', size: 24, bold: true })
                            ] 
                        }) 
                    ]
                }),
                new TableCell({
                    shading: { fill: '#8db3e2' }, 
                    verticalAlign: VerticalAlignTable.CENTER,
                    children: [ 
                        new Paragraph({ 
                            alignment: AlignmentType.CENTER, 
                            children: [ 
                                new TextRun({ text: `Definición`, font: 'Arial', size: 24, bold: true })
                            ] 
                        }) 
                    ]
                }),
                new TableCell({
                    shading: { fill: '#8db3e2' }, 
                    verticalAlign: VerticalAlignTable.CENTER,
                    children: [ 
                        new Paragraph({ 
                            alignment: AlignmentType.CENTER, 
                            children: [ 
                                new TextRun({ text: `Nivel de exposición`, font: 'Arial', size: 24, bold: true }),
                                new TextRun({ break: 1 }), 
                                new TextRun({ text: `Indique`, font: 'Arial', size: 20 }),
                                new TextRun({ text: ` alto, medio o bajo `, font: 'Arial', size: 20, bold: true }),
                                new TextRun({ text: `según la escala propuesta al pie de este cuadro`, font: 'Arial', size: 20 }),
                            ] 
                        }) 
                    ]
                }),
            ]
        });
        rows.push(titulo)
        if(data != null && data != undefined && data.length > 0) {
            data.forEach(a => {
                let dataRow = new TableRow({
                    children: [
                        new TableCell({
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.LEFT, 
                                    children: [ 
                                        new TextRun({ text: this.blankData(a.amenazaNombre), font: 'Arial', size: 24 })
                                    ] 
                                }) 
                            ]
                        }),
                        new TableCell({
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.LEFT, 
                                    children: [ 
                                        new TextRun({ text: this.blankData(a.amenazaDefinicion), font: 'Arial', size: 24 })
                                    ] 
                                }) 
                            ]
                        }),
                        new TableCell({
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.CENTER, 
                                    children: [ 
                                        new TextRun({ text: this.blankData(a.exposicionNombre), font: 'Arial', size: 24 })
                                    ] 
                                }) 
                            ]
                        }),
                    ]
                });
                rows.push(dataRow)
            })
        } else {
            let empyRow = this.emptyTableRow(4)
            rows.push(empyRow)
        }

        let amenazasTable = new Table({
            width: {
                size: 100,
                type: WidthType.PERCENTAGE,
            },
            rows: rows
        })

        return amenazasTable;
    }

    escalaValoracion() {
        let escalaable = new Table({
            layout: TableLayoutType.FIXED,
            width: {
                size: 100,
                type: WidthType.PERCENTAGE,
            },
            rows: [
                new TableRow({
                    children: [
                        new TableCell({
                            shading: { fill: '#8db3e2' }, 
                            verticalAlign: VerticalAlignTable.TOP,
                            width: { size: 3000, type: WidthType.DXA },
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.CENTER, 
                                    children: [ 
                                        new TextRun({ text: `Nivel de exposición`, font: 'Arial', size: 24, bold: true })
                                    ] 
                                }) 
                            ]
                        }),
                        new TableCell({
                            shading: { fill: '#8db3e2' }, 
                            verticalAlign: VerticalAlignTable.TOP,
                            width: { size: 7000, type: WidthType.DXA },
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.CENTER, 
                                    children: [ 
                                        new TextRun({ text: `Descripción`, font: 'Arial', size: 24, bold: true })
                                    ] 
                                }) 
                            ]
                        })
                    ]
                }),
                new TableRow({
                    children: [
                        new TableCell({
                            verticalAlign: VerticalAlignTable.TOP,
                            width: { size: 3000, type: WidthType.DXA },
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.CENTER, 
                                    children: [ 
                                        new TextRun({ text: 'Alto', font: 'Arial', size: 24 })
                                    ] 
                                }) 
                            ]
                        }),
                        new TableCell({
                            verticalAlign: VerticalAlignTable.TOP,
                            width: { size: 7000, type: WidthType.DXA },
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.LEFT, 
                                    children: [ 
                                        new TextRun({ text: 'La amenaza se ha presentado varias veces durante los últimos 5 años, afectando a la organización directamente y se pronostica que continuará presentándose en los próximos años', font: 'Arial', size: 24 })
                                    ] 
                                }) 
                            ]
                        })
                    ]
                }),
                new TableRow({
                    children: [
                        new TableCell({
                            verticalAlign: VerticalAlignTable.TOP,
                            width: { size: 3000, type: WidthType.DXA },
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.CENTER, 
                                    children: [ 
                                        new TextRun({ text: 'Medio', font: 'Arial', size: 24 })
                                    ] 
                                }) 
                            ]
                        }),
                        new TableCell({
                            verticalAlign: VerticalAlignTable.TOP,
                            width: { size: 7000, type: WidthType.DXA },
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.LEFT, 
                                    children: [ 
                                        new TextRun({ text: 'La amenaza se ha presentado varias veces durante los últimos 5 años y ha afectado a la organización indirectamente y se pronostica que continuará presentando en los próximos años.', font: 'Arial', size: 24 })
                                    ] 
                                }) 
                            ]
                        })
                    ]
                }),
                new TableRow({
                    children: [
                        new TableCell({
                            verticalAlign: VerticalAlignTable.TOP,
                            width: { size: 3000, type: WidthType.DXA },
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.CENTER, 
                                    children: [ 
                                        new TextRun({ text: 'Bajo', font: 'Arial', size: 24 })
                                    ] 
                                }) 
                            ]
                        }),
                        new TableCell({
                            verticalAlign: VerticalAlignTable.TOP,
                            width: { size: 7000, type: WidthType.DXA },
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.LEFT, 
                                    children: [ 
                                        new TextRun({ text: 'Caso 1: La amenaza se ha presentado en el pasado y no ha afectado a la organización, pero se pronostica que continuará presentando en los próximos años.', font: 'Arial', size: 24 }),
                                        new TextRun({ break: 2 }), 
                                        new TextRun({ text: 'Caso 2: Para la ubicación de la organización esta amenaza no está reportada ni se proyecta en el tiempo su ocurrencia.', font: 'Arial', size: 24 }),
                                    ] 
                                }) 
                            ]
                        })
                    ]
                })
            ]
        })
        return escalaable;
    }

    impactosClimaticos(data) {
        let rows = []
        let tituloRow = new TableRow({
            children: [
                new TableCell({
                    shading: { fill: '#8db3e2' }, 
                    verticalAlign: VerticalAlignTable.TOP,
                    width: { size: 6000, type: WidthType.DXA },
                    children: [ 
                        new Paragraph({ 
                            alignment: AlignmentType.CENTER, 
                            children: [ 
                                new TextRun({ text: 'Impacto', font: 'Arial', size: 24, bold: true })
                            ] 
                        }) 
                    ]
                }),
                new TableCell({
                    shading: { fill: '#8db3e2' }, 
                    verticalAlign: VerticalAlignTable.TOP,
                    width: { size: 2000, type: WidthType.DXA },
                    children: [ 
                        new Paragraph({ 
                            alignment: AlignmentType.CENTER, 
                            children: [ 
                                new TextRun({ text: 'Selección de los impactos', font: 'Arial', size: 24, bold: true }),
                                new TextRun({ break: 1 }),
                                new TextRun({ text: 'Marque con x ', font: 'Arial', size: 20 }),
                            ] 
                        }) 
                    ]
                }),
                new TableCell({
                    shading: { fill: '#8db3e2' }, 
                    verticalAlign: VerticalAlignTable.TOP,
                    width: { size: 2000, type: WidthType.DXA },
                    children: [ 
                        new Paragraph({ 
                            alignment: AlignmentType.CENTER, 
                            children: [ 
                                new TextRun({ text: 'Descripción del impacto', font: 'Arial', size: 24, bold: true })
                            ] 
                        }) 
                    ]
                })
            ]
        })
        rows.push(tituloRow)
        if (data !== undefined && data !== null) {
            const map = new Map(Object.entries(data));
            map.forEach((items, nivelImpacto) => {
                let impactRow = new TableRow({
                    children: [
                        new TableCell({
                            shading: { fill: '#8db3e2' }, 
                            columnSpan: 3,
                            verticalAlign: VerticalAlignTable.TOP,
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.CENTER, 
                                    children: [ 
                                        new TextRun({ text: `A nivel de ${nivelImpacto}`, font: 'Arial', size: 24 })
                                    ] 
                                }) 
                            ]
                        })
                    ]
                })
                rows.push(impactRow)
                items.forEach(im => {
                    let impacto = im.impacto;
                    let select = (im.seleccionado != null && im.seleccionado) ? "X" : "";
                    let row = new TableRow({
                        children: [
                            new TableCell({
                                verticalAlign: VerticalAlignTable.TOP,
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.LEFT, 
                                        children: [ 
                                            new TextRun({ text: this.blankData(impacto), font: 'Arial', size: 24 })
                                        ] 
                                    }),
                                ]
                            }),
                            new TableCell({
                                verticalAlign: VerticalAlignTable.TOP,
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.CENTER, 
                                        children: [ 
                                            new TextRun({ text: select, font: 'Arial', size: 24 })
                                        ] 
                                    }),
                                ]
                            }),
                            new TableCell({
                                verticalAlign: VerticalAlignTable.TOP,
                                children: [ 
                                    new Paragraph({ 
                                        alignment: AlignmentType.LEFT, 
                                        children: [ 
                                            new TextRun({ text: this.blankData(im.otro), font: 'Arial', size: 24 })
                                        ] 
                                    }),
                                ]
                            })
                        ]
                    })
                    rows.push(row)
                })
            })
        } else {
            let emptyRow = this.emptyTableRow(3)
            rows.push(emptyRow)
        }

        let impactosTable = new Table({
            width: {
                size: 100,
                type: WidthType.PERCENTAGE,
            },
            rows: rows
        })

        return impactosTable;
    }

    accionesAdaptacion(acciones) {
        let tablesList = []
        if(acciones != null && acciones != undefined && acciones.length > 0) {
            acciones.forEach((a, index) => {
                let rows = []
                let count = index + 1;
                let tituloUno = this.generateDataRow(`Actividad  N°${count}`, '#4bacc6', VerticalAlignTable.TOP, AlignmentType.LEFT);
                let tituloDos = this.generateDataRow(`Nombre de la acción de adaptación`, '#8db3e2', VerticalAlignTable.TOP, AlignmentType.LEFT);
                rows.push(tituloUno)
                rows.push(tituloDos)
                let accionRow = this.generateDataRow(a.nombre, null, VerticalAlignTable.TOP, AlignmentType.LEFT);
                rows.push(accionRow)
                let tituloTres = this.generateDataRow(`Amenazas climáticas a las que la acción ayuda a reducir y/o prevenir su impacto`, '#8db3e2', VerticalAlignTable.TOP, AlignmentType.LEFT);
                rows.push(tituloTres)
                let amenazasRow = this.generateDataRow(a.amenazas, null, VerticalAlignTable.TOP, AlignmentType.LEFT);
                rows.push(amenazasRow)
                let tituloCuat = this.generateDataRow(`Descripción de la acción:`, '#8db3e2', VerticalAlignTable.TOP, AlignmentType.LEFT);
                rows.push(tituloCuat)
                let descripRow = this.generateDataRow(a.descripcion, null, VerticalAlignTable.TOP, AlignmentType.LEFT);
                rows.push(descripRow)
                let tituloCinc = this.generateDataRow(`Evidencias de las acciones realizadas para implementar la acción`, '#8db3e2', VerticalAlignTable.TOP, AlignmentType.LEFT);
                rows.push(tituloCinc)
                let evidRows = this.evidenciasRows(a.evidencias)
                rows.push(...evidRows)

                let accionesTable = new Table({
                    width: {
                        size: 100,
                        type: WidthType.PERCENTAGE,
                    },
                    rows: rows
                })
                tablesList.push(accionesTable)
                let saltoLinea = this.espacioEnBlanco()
                tablesList.push(saltoLinea)
            })
        } else {
                let rows = []
                let tituloUno = this.generateDataRow(`Actividad  N°1`, '#4bacc6', VerticalAlignTable.TOP, AlignmentType.LEFT);
                let tituloDos = this.generateDataRow(`Nombre de la acción de adaptación`, '#8db3e2', VerticalAlignTable.TOP, AlignmentType.LEFT);
                rows.push(tituloUno)
                rows.push(tituloDos)
                let accionRow = this.generateDataRow(null, null, VerticalAlignTable.TOP, AlignmentType.CENTER);
                rows.push(accionRow)
                let tituloTres = this.generateDataRow(`Amenazas climáticas a las que la acción ayuda a reducir y/o prevenir su impacto`, '#8db3e2', VerticalAlignTable.TOP, AlignmentType.LEFT);
                rows.push(tituloTres)
                let amenazasRow = this.generateDataRow(null, null, VerticalAlignTable.TOP, AlignmentType.CENTER);
                rows.push(amenazasRow)
                let tituloCuat = this.generateDataRow(`Descripción de la acción:`, '#8db3e2', VerticalAlignTable.TOP, AlignmentType.LEFT);
                rows.push(tituloCuat)
                let descripRow = this.generateDataRow(null, null, VerticalAlignTable.TOP, AlignmentType.CENTER);
                rows.push(descripRow)
                let tituloCinc = this.generateDataRow(`Evidencias de las acciones realizadas para implementar la acción`, '#8db3e2', VerticalAlignTable.TOP, AlignmentType.LEFT);
                rows.push(tituloCinc)
                let evidRows = this.evidenciasRows(null)
                rows.push(...evidRows)

                let accionesTable = new Table({
                    width: {
                        size: 100,
                        type: WidthType.PERCENTAGE,
                    },
                    rows: rows
                })
                tablesList.push(accionesTable)
                let saltoLinea = this.espacioEnBlanco()
                tablesList.push(saltoLinea)
        }

        return tablesList;
    }

    actividadCompensacion(actividades, actividadesCompEvid, actCompDispEvid) {
        let tablesList = []
        if(actividades != null && actividades != undefined && actividades.length > 0) {
            actividades.forEach(a => {
                let sibae = (a.actEnSibae != null && a.actEnSibae) ? 'SI ( X )     NO (   )' : 'SI (   )     NO ( X )'
                let rows = []
                //creacion de la tabla fila por fila
                rows.push(this.generateDataRow(`Nombre y descripción de la actividad:`, '#8db3e2', VerticalAlignTable.TOP, AlignmentType.LEFT, 2, null, null, null))
                rows.push(this.generateDataRow(a.actividad, null, VerticalAlignTable.CENTER, AlignmentType.LEFT, 2, null))
                rows.push(this.generateDataRow([{ data: 'Parámetro asociado', width: 50}, {data: 'Cantidad de colaboradores de la Sede que participaron', width: 50 }], '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT))
                rows.push(this.generateDataRow([{ data: a.parametroAsociado.nombre, width: 50}, { data: `${a.cant_participantes}`, width: 50}], null, VerticalAlignTable.CENTER, AlignmentType.CENTER, null, null))
                rows.push(this.generateDataRow([{ data: 'Logros alcanzados', width: 50 }, { data: 'Beneficiarios (referirse a personas o lugares)', width: 50}], '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT))
                rows.push(this.generateDataRow([{ data: a.logros, width: 50 }, { data: a.beneficiarios, width: 50 }], null, VerticalAlignTable.CENTER, AlignmentType.LEFT, null, null))
                rows.push(this.generateDataRow(`Información de esta actividad se incluyó en el apartado Compensaciones del SIBAE`, '#4f81bd', VerticalAlignTable.TOP, AlignmentType.LEFT, 2, true))
                rows.push(this.generateDataRow(sibae, '#8db3e2', VerticalAlignTable.TOP, AlignmentType.LEFT, 2, null))
                rows.push(this.generateDataRow([{ data: 'Cantidad de árboles (en caso de que aplique)', width: 50 }, { data: 'Fecha de la actividad:', width: 50 }], '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT))
                rows.push(this.generateDataRow([{ data: `${a.cantArboles}`, width: 50 }, { data: this.dateFormat(a.fechaActividad), width: 50 }], null, VerticalAlignTable.CENTER, AlignmentType.CENTER, null, null))
                rows.push(this.generateDataRow(`Evidencias de la actividad y de la participación de trabajadores de la sede:`, '#8db3e2', VerticalAlignTable.TOP, AlignmentType.LEFT, 2, null))
                let evidencias = this.evidenciasRows(actividadesCompEvid, 2)
                rows.push(...evidencias)
                rows.push(this.generateDataRow(`Describir la disposición final de los residuos recuperados (en caso de que aplique):`, '#8db3e2', VerticalAlignTable.TOP, AlignmentType.LEFT, 2, null))
                rows.push(this.generateDataRow(a.disposicionFinal, null, VerticalAlignTable.CENTER, AlignmentType.LEFT, 2, null))
                rows.push(this.generateDataRow(`Evidencias de la disposición final de los residuos recuperados (en caso de que aplique):`, '#8db3e2', VerticalAlignTable.TOP, AlignmentType.LEFT, 2, null))
                let evidDispo = this.evidenciasRows(actCompDispEvid, 2)
                rows.push(...evidDispo)

                let actCompTable = new Table({
                    width: {
                        size: 100,
                        type: WidthType.PERCENTAGE,
                    },
                    rows: rows
                })
                tablesList.push(actCompTable)
                let saltoLinea = this.espacioEnBlanco()
                tablesList.push(saltoLinea)
            })
        } else {
            let rows = []
                //creacion de la tabla fila por fila
                rows.push(this.generateDataRow(`Nombre y descripción de la actividad:`, '#8db3e2', VerticalAlignTable.TOP, AlignmentType.LEFT, 2, null))
                rows.push(this.generateDataRow(null, null, VerticalAlignTable.CENTER, AlignmentType.CENTER, 2, null))
                rows.push(this.generateDataRow([{ data: 'Parámetro asociado', width: 50 }, { data: 'Cantidad de colaboradores de la Sede que participaron', width: 50}], '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT))
                rows.push(this.generateDataRow([{ data: null, width: 50 }, { data: null, width: 50 }], null, VerticalAlignTable.CENTER, AlignmentType.CENTER, null, null))
                rows.push(this.generateDataRow([{ data: 'Logros alcanzados', width: 50 }, { data: 'Beneficiarios (referirse a personas o lugares)', width: 50 }], '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT))
                rows.push(this.generateDataRow([{ data: null, width: 50 }, { data: null, width: 50 }], null, VerticalAlignTable.CENTER, AlignmentType.LEFT, null, null))
                rows.push(this.generateDataRow(`Información de esta actividad se incluyó en el apartado Compensaciones del SIBAE`, '#4f81bd', VerticalAlignTable.TOP, AlignmentType.LEFT, 2, true))
                rows.push(this.generateDataRow('SI (   )     NO ( X )', '#8db3e2', VerticalAlignTable.TOP, AlignmentType.LEFT, 2, null))
                rows.push(this.generateDataRow([{ data: 'Cantidad de árboles (en caso de que aplique)', width: 50 }, { data: 'Fecha de la actividad:', width: 50 }], '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT))
                rows.push(this.generateDataRow([{ data: null, width: 50 }, { data: null, width: 50 }], null, VerticalAlignTable.CENTER, AlignmentType.CENTER, null, null))
                rows.push(this.generateDataRow(`Evidencias de la actividad:`, '#8db3e2', VerticalAlignTable.TOP, AlignmentType.LEFT, 2, null))
                rows.push(this.generateDataRow(null, null, VerticalAlignTable.CENTER, AlignmentType.CENTER, 2, null))
                rows.push(this.generateDataRow(`Describir la disposición final de los residuos recuperados (en caso de que aplique):`, '#8db3e2', VerticalAlignTable.TOP, AlignmentType.LEFT, 2, null))
                rows.push(this.generateDataRow(null, null, VerticalAlignTable.CENTER, AlignmentType.CENTER, 2, null))
                rows.push(this.generateDataRow(`Evidencias de la disposición final de los residuos recuperados (en caso de que aplique):`, '#8db3e2', VerticalAlignTable.TOP, AlignmentType.LEFT, 2, null))
                rows.push(this.generateDataRow(null, null, VerticalAlignTable.CENTER, AlignmentType.CENTER, 2, null))

                let actCompTable = new Table({
                    width: {
                        size: 100,
                        type: WidthType.PERCENTAGE,
                    },
                    rows: rows
                })
                tablesList.push(actCompTable)
                let saltoLinea = this.espacioEnBlanco()
                tablesList.push(saltoLinea)
        }
        return tablesList
    }

    segundaEstrellaBlanca(datos, evidencias) {
        let tablesList = []
        let titulos = [
            { data: 'Nombre del Programa de gestión interno o reconocimiento externo o iniciativa para promover la salud integral y la felicidad', width: 40},
            { data: 'Descripción de lo realizado', width: 40 },
            { data: 'Fecha ejecución', width: 20 }
        ]
        if(datos != null && datos != undefined && datos.length > 0) {
            datos.forEach(d => {
                let rows = []

                rows.push(this.generateDataRow(titulos, '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.CENTER, null, null))
                rows.push(this.generateDataRow([{ data: d.nombre, width: 40 }, { data: d.descripcion, width: 40 }, { data: this.dateFormat(d.fechaEjecucion), width: 20 }], null, VerticalAlignTable.CENTER, AlignmentType.CENTER, null, null))
                rows.push(this.generateDataRow('Evidencias (constancias, certificados, fotografías u otros) del programa de gestión interno o reconocimiento externo o iniciativa para promover la salud integral y la felicidad', '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.CENTER, 3, null))
                let evidRows = this.evidenciasRows(evidencias, 3)
                rows.push(...evidRows)

                let estDosTable = new Table({
                    width: {
                        size: 100,
                        type: WidthType.PERCENTAGE,
                    },
                    rows: rows
                })
                tablesList.push(estDosTable)
                let saltoLinea = this.espacioEnBlanco()
                tablesList.push(saltoLinea)
            })
        } else {
                let rows = []

                rows.push(this.generateDataRow(titulos, '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.CENTER, null, null))
                rows.push(this.generateDataRow([{ data: null, width: 40 }, { data: null, width: 40 }, { data: null, width: 20 }], null, VerticalAlignTable.CENTER, AlignmentType.CENTER, null, null))
                rows.push(this.generateDataRow('Evidencias (constancias, certificados, fotografías u otros) del programa de gestión interno o reconocimiento externo o iniciativa para promover la salud integral y la felicidad', '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.CENTER, 3, null))
                rows.push(this.generateDataRow(null, null, VerticalAlignTable.CENTER, AlignmentType.CENTER, 3, null))

                let estDosTable = new Table({
                    width: {
                        size: 100,
                        type: WidthType.PERCENTAGE,
                    },
                    rows: rows
                })
                tablesList.push(estDosTable)
                let saltoLinea = this.espacioEnBlanco()
                tablesList.push(saltoLinea)
        }
        return tablesList
    }

    terceraEstrellaBlanca(datos) {
        let tablesList = []
        let titulos = [ { data: 'Nombre empresa o personas que se les promovió el PBAE, y tipo de actividad económica (en caso de que aplique):', width: 50 }, { data: 'Fecha de la actividad:', width: 50} ]
        let titulosDos = [ { data: 'La organización o persona que se le promovió el PBAE obtuvo galardón el año anterior en alguna de las Categorías del PBAE:', width: 50 }, { data: 'Relación con la organización (marque con una X):', width: 50 } ]
        if(datos != null && datos != undefined && datos.length > 0) {
            datos.forEach((d, index) => {
                let count = index + 1;
                let rows = []

                rows.push(this.generateDataRow(`Actividad N°${count}:`, '#4bacc6', VerticalAlignTable.CENTER, AlignmentType.LEFT, 2, null))
                rows.push(this.generateDataRow(titulos, '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, null, null))
                rows.push(this.generateDataRow([{ data: d.interesado, width: 50 }, { data: this.dateFormat(d.fechaActividad), width: 50 }], null, VerticalAlignTable.CENTER, AlignmentType.CENTER, null, null))
                rows.push(this.generateDataRow(titulosDos, '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, null, null))
                rows.push(this.generateDataRow([{ data: this.estrellaTresGalardo(d.categoriaPbae), width: 50 }, { data: this.estrellaTresRelacion(d.listaParticipante), width: 50 }], null, VerticalAlignTable.CENTER, AlignmentType.LEFT, null, null))
                rows.push(this.generateDataRow('Descripción de la actividad realizada:', '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, 3, null))
                rows.push(this.generateDataRow(d.descripcionActividad, null, VerticalAlignTable.CENTER, AlignmentType.LEFT, 3, null))
                rows.push(this.generateDataRow('Evidencias:', '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, 3, null))
                rows.push(this.generateDataRow('Fotografías de las actividades:', '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, 3, null))
                let evidRows = this.evidenciasRows(d.docActividad, 3)
                rows.push(...evidRows)
                rows.push(this.generateDataRow('Lista de Asistencia:', '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, 3, null))
                let evidAsistRows = this.evidenciasRows(d.docAsistencia, 3)
                rows.push(...evidAsistRows)
                rows.push(this.generateDataRow('Otras:', '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, 3, null))
                let evidotrasRows = this.evidenciasRows(d.docEvidencia, 3)
                rows.push(...evidotrasRows)

                let estDosTable = new Table({
                    width: {
                        size: 100,
                        type: WidthType.PERCENTAGE,
                    },
                    rows: rows
                })
                tablesList.push(estDosTable)
                let saltoLinea = this.espacioEnBlanco()
                tablesList.push(saltoLinea)
            })
        } else {
                let rows = []

                rows.push(this.generateDataRow(`Actividad N°1:`, '#4bacc6', VerticalAlignTable.CENTER, AlignmentType.LEFT, 2, null))
                rows.push(this.generateDataRow(titulos, '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, null, null))
                rows.push(this.generateDataRow([{ data: null, width: 50 } , { data: null, width: 50 }], null, VerticalAlignTable.CENTER, AlignmentType.CENTER, null, null))
                rows.push(this.generateDataRow(titulosDos, '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, null, null))
                rows.push(this.generateDataRow([{ data: this.estrellaTresGalardo(null), width: 50 }, { data: this.estrellaTresRelacion(null), width: 50 }], null, VerticalAlignTable.CENTER, AlignmentType.LEFT, null, null))
                rows.push(this.generateDataRow('Descripción de la actividad realizada:', '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, 3, null))
                rows.push(this.generateDataRow(null, null, VerticalAlignTable.CENTER, AlignmentType.CENTER, 3, null))
                rows.push(this.generateDataRow('Evidencias:', '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, 3, null))
                rows.push(this.generateDataRow('Fotografías de las actividades:', '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, 3, null))
                rows.push(this.generateDataRow(null, null, VerticalAlignTable.CENTER, AlignmentType.CENTER, 3, null))
                rows.push(this.generateDataRow('Lista de Asistencia:', '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, 3, null))
                rows.push(this.generateDataRow(null, null, VerticalAlignTable.CENTER, AlignmentType.CENTER, 3, null))
                rows.push(this.generateDataRow('Otras:', '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, 3, null))
                rows.push(this.generateDataRow(null, null, VerticalAlignTable.CENTER, AlignmentType.CENTER, 3, null))

                let estDosTable = new Table({
                    width: {
                        size: 100,
                        type: WidthType.PERCENTAGE,
                    },
                    rows: rows
                })
                tablesList.push(estDosTable)
                let saltoLinea = this.espacioEnBlanco()
                tablesList.push(saltoLinea)
        }
        return tablesList
    }

    cuartaEstrellaBlanca(datos) {
        let tablesList = []
        let titulos = [ { data: 'Nombre organización o personas que se les promovió el PBAE, y tipo de actividad económica (en caso de que aplique):', width: 50 }, { data: 'Fecha de la actividad:', width: 50 } ]
        let titulosDos = 'La organización o personas que se le promovió el PBAE obtuvo galardón el año anterior en alguna de las Categorías del PBAE:'
        if(datos != null && datos != undefined && datos.length > 0) {
            datos.forEach((d, index) => {
                let count = index + 1;
                let rows = []

                rows.push(this.generateDataRow(`Actividad N°${count}:`, '#4bacc6', VerticalAlignTable.CENTER, AlignmentType.LEFT, 2, null))
                rows.push(this.generateDataRow(titulos, '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, null, null))
                rows.push(this.generateDataRow([{ data: d.interesado, width: 50 }, { data: this.dateFormat(d.fechaActividad), width: 50 }], null, VerticalAlignTable.CENTER, AlignmentType.CENTER, null, null))
                rows.push(this.generateDataRow(titulosDos, '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, 2, null))
                rows.push(this.generateDataRow(this.estrellaTresGalardo(d.categoriaPbae), null, VerticalAlignTable.CENTER, AlignmentType.LEFT, 2, null))
                rows.push(this.generateDataRow('Descripción de la actividad realizada:', '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, 2, null))
                rows.push(this.generateDataRow(d.descripcionActividad, null, VerticalAlignTable.CENTER, AlignmentType.LEFT, 2, null))
                rows.push(this.generateDataRow('Evidencias:', '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, 2, null))
                rows.push(this.generateDataRow('Fotografías de las actividades:', '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, 2, null))
                let evidRows = this.evidenciasRows(d.docActividad, 2)
                rows.push(...evidRows)
                rows.push(this.generateDataRow('Lista de Asistencia:', '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, 2, null))
                let evidAsistRows = this.evidenciasRows(d.docAsistencia, 3)
                rows.push(...evidAsistRows)
                rows.push(this.generateDataRow('Otras:', '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, 2, null))
                let evidotrasRows = this.evidenciasRows(d.docEvidencia, 3)
                rows.push(...evidotrasRows)

                let estDosTable = new Table({
                    width: {
                        size: 100,
                        type: WidthType.PERCENTAGE,
                    },
                    rows: rows
                })
                tablesList.push(estDosTable)
                let saltoLinea = this.espacioEnBlanco()
                tablesList.push(saltoLinea)
            })
        } else {
                let rows = []

                rows.push(this.generateDataRow(`Actividad N°1:`, '#4bacc6', VerticalAlignTable.CENTER, AlignmentType.LEFT, 2, null))
                rows.push(this.generateDataRow(titulos, '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, null, null))
                rows.push(this.generateDataRow([{ data: null, width: 50 }, { data: null, width: 50 }], null, VerticalAlignTable.CENTER, AlignmentType.CENTER, null, null))
                rows.push(this.generateDataRow(titulosDos, '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, 2, null))
                rows.push(this.generateDataRow(this.estrellaTresGalardo(null), null, VerticalAlignTable.CENTER, AlignmentType.LEFT, 2, null))
                rows.push(this.generateDataRow('Descripción de la actividad realizada:', '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, 2, null))
                rows.push(this.generateDataRow(null, null, VerticalAlignTable.CENTER, AlignmentType.CENTER, 2, null))
                rows.push(this.generateDataRow('Evidencias:', '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, 2, null))
                rows.push(this.generateDataRow('Fotografías de las actividades:', '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, 2, null))
                rows.push(this.generateDataRow(null, null, VerticalAlignTable.CENTER, AlignmentType.CENTER, 2, null))
                rows.push(this.generateDataRow('Lista de Asistencia:', '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, 3, null))
                rows.push(this.generateDataRow(null, null, VerticalAlignTable.CENTER, AlignmentType.CENTER, 2, null))
                rows.push(this.generateDataRow('Otras:', '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, 2, null))
                rows.push(this.generateDataRow(null, null, VerticalAlignTable.CENTER, AlignmentType.CENTER, 2, null))

                let estDosTable = new Table({
                    width: {
                        size: 100,
                        type: WidthType.PERCENTAGE,
                    },
                    rows: rows
                })
                tablesList.push(estDosTable)
                let saltoLinea = this.espacioEnBlanco()
                tablesList.push(saltoLinea)
        }
        return tablesList
    }

    quintaEstrellaBlanca(datos) {
        let tablesList = []
        let bold = true;
        if(datos != null && datos != undefined && datos.length > 0) {
            datos.forEach((d, index) => {
                let rows = []

                rows.push(this.generateDataRow([{ data: 'Año de reporte:', width: 50}, { data: this.dateFormat(d.fechaCuantificacion), width: 50}], '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.CENTER, null, null))
                rows.push(this.generateDataRow([{ data: 'Nombre de la norma aplicada para la cuantificación:', width: 50 }, { data: d.normativaReferencia, width: 50 }], '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.CENTER, null, null))
                rows.push(this.generateDataRow('Emisiones reportadas (tCO2e)', '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.CENTER, 2, null, bold))
                rows.push(this.generateDataRow([{ data: 'Alcance 1:', width: 50 }, { data: d.primerAlcance, width: 50 }], '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.CENTER, null, null))
                rows.push(this.generateDataRow([{ data: 'Alcance 2:', width: 50 }, { data: d.segundoAlcance, width: 50 }], '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.CENTER, null, null))
                rows.push(this.generateDataRow([{ data: 'Alcance 3:', width: 50 }, { data: d.tercerAlcance, width: 50 }], '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.CENTER, null, null))
                rows.push(this.generateDataRow([{ data: 'Total de emisiones reportadas:', width: 50}, { data: d.emisionCo2, width: 50}], '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.CENTER, null, null))
                rows.push(this.generateDataRow('Evidencia de la cuantificación:', '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, 2, null, bold))
                rows.push(this.generateDataRow('Fotografías del reporte o gráficos del inventario:', '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, 2, null))
                let evidRows = this.evidenciasRows(d.docActividad, 2)
                rows.push(...evidRows)
                //rows.push(this.generateDataRow('Lista de Asistencia:', '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, 2, null))
                //let evidAsistRows = this.evidenciasRows(d.docAsistencia, 2)
                //rows.push(...evidAsistRows)
                rows.push(this.generateDataRow('Otras:', '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, 2, null))
                let evidotrasRows = this.evidenciasRows(d.docEvidencia, 2)
                let evidAsistRows = this.evidenciasRows(d.docAsistencia, 2)// se mueve analisis Yazmin
                rows.push(...evidotrasRows)
                rows.push(...evidAsistRows)

                let estDosTable = new Table({
                    width: {
                        size: 100,
                        type: WidthType.PERCENTAGE,
                    },
                    rows: rows
                })
                tablesList.push(estDosTable)
                let saltoLinea = this.espacioEnBlanco()
                tablesList.push(saltoLinea)
            })
        } else {
                let rows = []

                rows.push(this.generateDataRow([{ data: 'Año de reporte:', width: 50 }, { data: null, width: 50 }], '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.CENTER, null, null))
                rows.push(this.generateDataRow([{ data: 'Nombre de la norma aplicada para la cuantificación:', width: 50 }, { data: null, width: 50 }], '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.CENTER, null, null))
                rows.push(this.generateDataRow('Emisiones reportadas (tCO2e)', '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.CENTER, 2, null, bold))
                rows.push(this.generateDataRow([{ data: 'Alcance 1:', width: 50 }, { data: null, width: 50 }], '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.CENTER, null, null))
                rows.push(this.generateDataRow([{ data: 'Alcance 2:', width: 50 }, { data: null, width: 50 }], '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.CENTER, null, null))
                rows.push(this.generateDataRow([{ data: 'Alcance 3:', width: 50 }, { data: null, width: 50 }], '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.CENTER, null, null))
                rows.push(this.generateDataRow([{ data: 'Total de emisiones reportadas:', width: 50 }, { data: null, width: 50 }], '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.CENTER, null, null))
                rows.push(this.generateDataRow('Evidencia de la cuantificación:', '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, 2, null, bold))
                rows.push(this.generateDataRow('Fotografías del reporte o gráficos del inventario:', '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, 2, null))
                let evidRows = this.evidenciasRows(null, 2)
                rows.push(...evidRows)
                rows.push(this.generateDataRow('Lista de Asistencia:', '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, 2, null))
                let evidAsistRows = this.evidenciasRows(null, 2)
                rows.push(...evidAsistRows)
                rows.push(this.generateDataRow('Otras:', '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, 2, null))
                let evidotrasRows = this.evidenciasRows(null, 2)
                rows.push(...evidotrasRows)

                let estDosTable = new Table({
                    width: {
                        size: 100,
                        type: WidthType.PERCENTAGE,
                    },
                    rows: rows
                })
                tablesList.push(estDosTable)
                let saltoLinea = this.espacioEnBlanco()
                tablesList.push(saltoLinea)
        }
        return tablesList
    }

    sextaEstrellaBlanca(datos, opcion) {
        let childrenList = []
        let tipoDetalle = opcion == 1 ? 'Certificado del reconocimiento o Constancia de declaración de verificación' : 'Constancia de declaración de verificación'
        let bold = true;
        let titulo = new Paragraph({
            alignment: AlignmentType.CENTER,
            spacing: { after: 250, before:100 },
            children: [ 
                new TextRun( { text: `Cuadro N°47`, font: 'Arial', size: 28, color: '#365F91' } ),
                new TextRun({ break: 1 }), 
                new TextRun( { text: `Reconocimientos para optar por seis estrellas blancas`, font: 'Arial', size: 28, color: '#365F91' } )
            ]
        })
        childrenList.push(titulo)
        let rows = []
        const certs = datos.filter(cn => cn.opcion == opcion)
        const evidencias = certs.flatMap(cn => cn.evidencias);

        if(certs != null && certs != undefined && certs.length > 0) {
            rows.push(this.generateDataRow([{ data: 'Fecha de la certificación', width: 50 }, { data: 'Nombre del reconocimiento', width: 50 }], '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.CENTER, null, null))
            certs.forEach(d => {
                rows.push(this.generateDataRow([{ data: this.dateFormat(d.fechaCuantificacion), width: 50 }, { data: d.normativaReferencia, width: 50 }], null, VerticalAlignTable.CENTER, AlignmentType.CENTER, null, null))
            })
            rows.push(this.generateDataRow('Evidencia', '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, 2, null, bold))
            rows.push(this.generateDataRow(tipoDetalle, '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, 2, null))
            let evidRows = this.evidenciasTipoRows(evidencias, 2, this.constantes.CERT_CARBONO_NEUTRAL)
            rows.push(...evidRows)
            /* rows.push(this.generateDataRow('Otras:', '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, 2, null))
            let evidOtrasRows = this.evidenciasTipoRows(evidencias, 2, this.constantes.OTROS_CARBONO_NEUTRAL)
            rows.push(...evidOtrasRows) */ //omitido Yazmin analisis 2026
        } else {
            rows.push(this.generateDataRow([{ data: 'Fecha de la certificación', width: 50 }, { data: 'Nombre del reconocimiento', width: 50 }], '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.CENTER, null, null))
            rows.push(this.generateDataRow([{ data: null, width: 50 }, { data: null, width: 50 }], null, VerticalAlignTable.CENTER, AlignmentType.CENTER, null, null))
            rows.push(this.generateDataRow('Evidencia', '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, 2, null, bold))
            rows.push(this.generateDataRow(tipoDetalle, '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, 2, null))
            let evidRows = this.evidenciasRows(null, 2)
            rows.push(...evidRows)
            rows.push(this.generateDataRow('Otras:', '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, 2, null))
            let evidOtrasRows = this.evidenciasRows(null, 2)
            rows.push(...evidOtrasRows)
        }

        let sextaEstrellaTable = new Table({
            width: {
                size: 100,
                type: WidthType.PERCENTAGE,
            },
            rows: rows
        })
        childrenList.push(sextaEstrellaTable)
        let saltoLinea = this.espacioEnBlanco()
        childrenList.push(saltoLinea)

        return childrenList
    }

    estrellaVerdeTable(datos) {
        let rows = []
        let encabezados = [
            { data: 'Nombre del Hogar Sostenible inscrito', width: 20 },
            { data: 'Hogar presentó informe final (SI/NO)', width: 15 },
            { data: 'Nota obtenida', width: 15 },
            { data: 'Gradación de estrellas obtenidas', width: 20 },
            { data: '¿Cuántos años han acompañado a este hogar?', width: 15 },
            { data: '¿Hogar fue galardonado el año anterior? (SI/NO)', width: 15 }
        ]
        rows.push(this.generateDataRow(encabezados, '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.CENTER, null, null))
        if(datos != null && datos != undefined && datos.length > 0) {
            datos.forEach(d => {
                let rowData = [{ data: d.nombre, width: 20 }, { data: d.informeFinal, width: 15 }, { data: `${d.calificacionFinal}`, width: 15 }, { data: `${d.estrellasGanadas}`, width: 20 }, { data: `${d.aniosAcomp}`, width: 15 }, { data: d.galardonAnterior, width: 15 }]
                rows.push(this.generateDataRow(rowData, null, VerticalAlignTable.CENTER, AlignmentType.CENTER, null, null))
            })
        } else {
            rows.push(this.generateDataRow([
                { data: null, width: 20 }, 
                { data: null, width: 15 }, 
                { data: null, width: 15 }, 
                { data: null, width: 20 }, 
                { data: null, width: 15 }, 
                { data: null, width: 15 }
            ], null, VerticalAlignTable.CENTER, AlignmentType.CENTER, null, null))
        }

        let estrellaVerdeTable = new Table({
            width: {
                size: 100,
                type: WidthType.PERCENTAGE,
            },
            rows: rows
        })
        return estrellaVerdeTable
    }

    estrellaVerdeEvidencias(evidencias) {
        let rows = []
        let bold = true
        rows.push(this.generateDataRow('Evidencia de la asesoría, acompañamiento y seguimiento:', '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, null, null, bold))
        rows.push(this.generateDataRow('Fotografías:', '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, null, null))
        let docs = this.evidenciasTipoRows(evidencias, 2, this.constantes.CERT_HOGAR_INSCRITO)
        rows.push(...docs)
        rows.push(this.generateDataRow('Otras:', '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.LEFT, null, null))
        let docsOtros = this.evidenciasTipoRows(evidencias, 2, this.constantes.OTROS_HOGAR_INSCRITO)
        rows.push(...docsOtros)

        let estrellaVerdeEvTable = new Table({
            width: {
                size: 100,
                type: WidthType.PERCENTAGE,
            },
            rows: rows
        })
        return estrellaVerdeEvTable
    }

    estrellaPlateadaTable(correoEcocolones, ecolonesCasoUno, ecolonesCasoDos, ecolonesCasoTres) {
        let rows = []
        let centroAcop = (ecolonesCasoUno != undefined && ecolonesCasoUno.length > 0) ? 'X' : ''
        let campRecupRe = (ecolonesCasoDos != undefined && ecolonesCasoDos.length > 0) ? 'X' : ''
        let entregResid = (ecolonesCasoTres != undefined && ecolonesCasoTres.length > 0) ? 'X' : ''
        rows.push(this.generateDataRow('Correo electrónico registrado en ecoins:', '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.CENTER, 2, null))
        rows.push(this.generateDataRow(correoEcocolones, null, VerticalAlignTable.CENTER, AlignmentType.CENTER, null, null))
        let rowUno = new TableRow({
            children: [
                new TableCell({
                    shading: { fill: '#8db3e2' },
                    verticalAlign: VerticalAlignTable.TOP,
                    children: [
                        new Paragraph({ 
                            alignment: AlignmentType.LEFT, 
                            children: [
                                new TextRun({ text: '1.', font: 'Arial', size: 24, bold: true }),
                                new TextRun({ text: ' Apertura centros de acopio permanentes', font: 'Arial', size: 24 })
                            ]
                        })
                    ]
                }),
                new TableCell({
                    verticalAlign: VerticalAlignTable.CENTER,
                    children: [
                        new Paragraph({ 
                            alignment: AlignmentType.CENTER, 
                            children: [
                                new TextRun({ text: centroAcop, font: 'Arial', size: 24, bold: true })
                            ],
                        })
                    ]
                })
            ]
        })
        let rowDos = new TableRow({
            children: [
                new TableCell({
                    shading: { fill: '#8db3e2' },
                    verticalAlign: VerticalAlignTable.TOP,
                    children: [
                        new Paragraph({ 
                            alignment: AlignmentType.LEFT, 
                            children: [
                                new TextRun({ text: '2.', font: 'Arial', size: 24, bold: true }),
                                new TextRun({ text: ' Campañas de recuperación de residuos valorizables (centros de acopio esporádicos)', font: 'Arial', size: 24 })
                            ]
                        })
                    ]
                }),
                new TableCell({
                    verticalAlign: VerticalAlignTable.CENTER,
                    children: [
                        new Paragraph({ 
                            alignment: AlignmentType.CENTER, 
                            children: [
                                new TextRun({ text: campRecupRe, font: 'Arial', size: 24, bold: true })
                            ],
                        })
                    ]
                })
            ]
        })
        let rowTres = new TableRow({
            children: [
                new TableCell({
                    shading: { fill: '#8db3e2' },
                    verticalAlign: VerticalAlignTable.TOP,
                    children: [
                        new Paragraph({ 
                            alignment: AlignmentType.LEFT, 
                            children: [
                                new TextRun({ text: '3.', font: 'Arial', size: 24, bold: true }),
                                new TextRun({ text: ' Entrega de residuos a centros de acopio, gestores autorizados o municipalidad', font: 'Arial', size: 24 })
                            ]
                        })
                    ]
                }),
                new TableCell({
                    verticalAlign: VerticalAlignTable.CENTER,
                    children: [
                        new Paragraph({ 
                            alignment: AlignmentType.CENTER, 
                            children: [
                                new TextRun({ text: entregResid, font: 'Arial', size: 24, bold: true })
                            ],
                        })
                    ]
                })
            ]
        })
        rows.push(rowUno)
        rows.push(rowDos)
        rows.push(rowTres)
        

        let estrellaVerdeTable = new Table({
            width: {
                size: 100,
                type: WidthType.PERCENTAGE,
            },
            rows: rows
        })
        return estrellaVerdeTable
    }

    estrellaNaranjaTable(datos) {
        let estNaramjaSi = ''
        let estNaramjaNo = ''
        let incluidaSi = ''
        let incluidaNo = ''
        if(datos != null && datos != undefined && datos.length > 0) {
            estNaramjaSi = 'X'
            if(datos[0].incluida) {
                incluidaSi = 'X'
            } else {
                incluidaNo = 'X'
            }
        } else {
            estNaramjaNo = 'X'
            incluidaNo = 'X'
        }
        let rows = []
        let rowEncab = new TableRow({
            children: [
                new TableCell({
                    columnSpan: 2,
                    shading: { fill: '#8db3e2' },
                    verticalAlign: VerticalAlignTable.CENTER,
                    children: [
                        new Paragraph({ 
                            alignment: AlignmentType.CENTER, 
                            children: [
                                new TextRun({ text: 'Esta Sede opta por la estrella anaranjada', font: 'Arial', size: 24 }),
                                new TextRun({ break: 1 }),
                                new TextRun({ text: '(marcar con X)', font: 'Arial', size: 24 }),
                            ]
                        })
                    ]
                }),
                new TableCell({
                    columnSpan: 2,
                    shading: { fill: '#8db3e2' },
                    verticalAlign: VerticalAlignTable.CENTER,
                    children: [
                        new Paragraph({ 
                            alignment: AlignmentType.CENTER, 
                            children: [
                                new TextRun({ text: 'Información de las actividades realizadas se presentaron mediante el llenado del formulario respectivo (marque con X)', font: 'Arial', size: 24 })
                            ],
                        })
                    ]
                })
            ]
        })
        let rowUno = new TableRow({
            children: [
                new TableCell({
                    shading: { fill: '#8db3e2' },
                    verticalAlign: VerticalAlignTable.TOP,
                    children: [
                        new Paragraph({ 
                            alignment: AlignmentType.CENTER, 
                            children: [
                                new TextRun({ text: 'SI', font: 'Arial', size: 24 })
                            ]
                        })
                    ]
                }),
                new TableCell({
                    verticalAlign: VerticalAlignTable.CENTER,
                    children: [
                        new Paragraph({ 
                            alignment: AlignmentType.CENTER, 
                            children: [
                                new TextRun({ text: estNaramjaSi, font: 'Arial', size: 24 })
                            ],
                        })
                    ]
                }),
                new TableCell({
                    shading: { fill: '#8db3e2' },
                    verticalAlign: VerticalAlignTable.TOP,
                    children: [
                        new Paragraph({ 
                            alignment: AlignmentType.CENTER, 
                            children: [
                                new TextRun({ text: 'SI', font: 'Arial', size: 24 })
                            ]
                        })
                    ]
                }),
                new TableCell({
                    verticalAlign: VerticalAlignTable.CENTER,
                    children: [
                        new Paragraph({ 
                            alignment: AlignmentType.CENTER, 
                            children: [
                                new TextRun({ text: incluidaSi, font: 'Arial', size: 24 })
                            ],
                        })
                    ]
                })
            ]
        })
        let rowDos = new TableRow({
            children: [
                new TableCell({
                    shading: { fill: '#8db3e2' },
                    verticalAlign: VerticalAlignTable.TOP,
                    children: [
                        new Paragraph({ 
                            alignment: AlignmentType.CENTER, 
                            children: [
                                new TextRun({ text: 'NO', font: 'Arial', size: 24 })
                            ]
                        })
                    ]
                }),
                new TableCell({
                    verticalAlign: VerticalAlignTable.CENTER,
                    children: [
                        new Paragraph({ 
                            alignment: AlignmentType.CENTER, 
                            children: [
                                new TextRun({ text: estNaramjaNo, font: 'Arial', size: 24 })
                            ],
                        })
                    ]
                }),
                new TableCell({
                    shading: { fill: '#8db3e2' },
                    verticalAlign: VerticalAlignTable.TOP,
                    children: [
                        new Paragraph({ 
                            alignment: AlignmentType.CENTER, 
                            children: [
                                new TextRun({ text: 'NO', font: 'Arial', size: 24 })
                            ]
                        })
                    ]
                }),
                new TableCell({
                    verticalAlign: VerticalAlignTable.CENTER,
                    children: [
                        new Paragraph({ 
                            alignment: AlignmentType.CENTER, 
                            children: [
                                new TextRun({ text: incluidaNo, font: 'Arial', size: 24 })
                            ],
                        })
                    ]
                })
            ]
        })
        
        rows.push(rowEncab)
        rows.push(rowUno)
        rows.push(rowDos)

        let estrellaVerdeTable = new Table({
            width: {
                size: 100,
                type: WidthType.PERCENTAGE,
            },
            rows: rows
        })
        return estrellaVerdeTable
    }

    estrellaTresGalardo(data) {
        let ganoPbae = (data != null && data != undefined && data > 0)
        let result = ``
        if(ganoPbae) {
            result = `Si: X, ¿Cuál? ${data} \n NO:_____`
        } else {
            result = `Si: _____, ¿Cuál? _____ \n NO: X`
        }
        return result
    }

    estrellaTresRelacion(data) {
        let hasParticipantes = (data != null && data != undefined && data > 0)
        let result = ``
        if(hasParticipantes) {
            result = '\n'
            result += data.includes('Colaboradores') ? `Trabajadores: X ` : `Trabajadores:___`
            result += data.includes('Clientes') ? `   Clientes: X ` : `   Clientes:___\n`
            result += data.includes('Proveedores') ? `Proveedores: X ` : `Proveedores:___`
            result += data.includes('Subcontratistas') ? `   Subcontratistas: X ` : `   Subcontratistas:___\n`
            result += data.includes('Distribuidores') ? `Distribuidores: X ` : `Distribuidores:___`
            result += '   Otro (especifique)\n';
            result += '\n'
        } else {
            result = '\n'
            result += `Trabajadores:___`
            result += `   Clientes:___\n`
            result += `Proveedores:___`
            result += `   Subcontratistas:___\n`
            result += `Distribuidores:___`
            result += '   Otro (especifique)'
            result += '\n'
        }
        return result
    }

    numberFormat(number) {
        return number.toLocaleString("es-CR", { minimumFractionDigits: 2 });
    }

    dateFormat(date) {
        return moment(date).format("DD/MM/YYYY")
    }

    espacioEnBlanco() {
        return new Paragraph({ text: "", spacing: { after: 100 } });//espacio en blanco
    }

    generateDataRow(data, rowColor, verticalAlign, horizontalAlign, colSpan, rowSpan, boldText, textColor) {
        let row = null
        rowColor = (rowColor != null && rowColor != undefined) ? rowColor : '#FFFFFF'
        rowSpan =  (rowSpan != null && rowSpan != undefined) ? rowSpan : 1
        colSpan =  (colSpan != null && colSpan != undefined) ? colSpan : 1
        boldText = (boldText != null && boldText != undefined) ? boldText : false
        textColor = (textColor != null && textColor != undefined) ? textColor : '#000000'
        
        if(data != null && data != undefined && Array.isArray(data)) {
            let columns = []
            data.forEach(d => {
                let col = new TableCell({
                    columnSpan: colSpan,
                    shading: { fill: rowColor, }, 
                    verticalAlign: verticalAlign,
                    width: { size: d.width, type: WidthType.PERCENTAGE },
                    children: [ 
                        new Paragraph({ 
                            alignment: horizontalAlign, 
                            children: [ 
                                new TextRun({ text: this.blankData(d.data), font: 'Arial', size: 24, bold: boldText, color: textColor })
                            ] 
                        }) 
                    ]
                })
                columns.push(col)
            })
            row = new TableRow({
                rowSpan: rowSpan,
                children: columns
            })
        } else {
            row = new TableRow({
                children: [
                    new TableCell({
                        columnSpan: colSpan,
                        shading: { fill: rowColor, },
                        verticalAlign: verticalAlign,
                        width: { size: 100, type: WidthType.PERCENTAGE },
                        children: [ 
                            new Paragraph({ 
                                alignment: horizontalAlign, 
                                children: [ 
                                    new TextRun({ text: this.blankData(data), font: 'Arial', size: 24, bold: boldText, color: textColor })
                                ] 
                            }) 
                        ]
                    })
                ]
            })
        }
        
        return row
    }

    dataEducacion(actividad, facilitador) {
        actividad = (actividad != undefined && actividad != null) ? actividad : 'N/A'
        facilitador = (facilitador != undefined && facilitador != null) ? facilitador : 'N/A'
        return `Actividad: ${actividad}, Facilitador: ${facilitador}`
    }

    headerLogo(logo) {
        const tipo = this.detectarTipoImagen(imagen);
        return new ImageRun({
            data: this.base64ToUint8Array(logo),
            type: tipo,
            transformation: {
                width: 15, 
                height: 50,
            },
        })
    }

    generateImageRun(imageBase64, widthPx, heightPx) {
        const match = imageBase64.match(/^data:image\/([a-zA-Z0-9+]+);base64,/);
        const imageType = match ? match[1] : null;
        let imageRun = new ImageRun({
            data: this.base64ToUint8Array(imageBase64),
            transformation: {
                width: widthPx, 
                height: heightPx,
            },
            type: imageType
        })
        return imageRun;
    }

    orgGeneralidades2026(datos, instalacion) {
        let historial = datos.historialEstrella;
        let dataRows = [
            new TableRow({
                children: [
                    new TableCell({
                        columnSpan: 3,
                        shading: { fill: '#8db3e2' },
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ children: [ new TextRun({ text: 'Nombre de la organización', font: 'Arial', size: 24 }) ] }) ]
                    }),
                    new TableCell({
                        columnSpan: 3,
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ children: [ new TextRun({ text: datos.organizacionNombre, font: 'Arial', size: 24 }) ] }) ]
                    })
                ]
            }),
            new TableRow({
                children: [
                    new TableCell({
                        columnSpan: 3,
                        shading: { fill: '#8db3e2' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ children: [ new TextRun({ text: 'Nombre de la sede', font: 'Arial', size: 24 }) ] }) ]
                    }),
                    new TableCell({
                        columnSpan: 3,
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ children: [ new TextRun({ text: instalacion.nombre, font: 'Arial', size: 24 }) ] }) ]
                    })
                ]
            }),
            new TableRow({
                children: [
                    new TableCell({
                        columnSpan: 3,
                        shading: { fill: '#8db3e2' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ children: [ new TextRun({ text: 'Código de comité', font: 'Arial', size: 24 }) ] }) ]
                    }),
                    new TableCell({
                        columnSpan: 3,
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ children: [ new TextRun({ text:  instalacion.codigoPbae, font: 'Arial', size: 24 }) ] }) ]
                    })
                ]
            }),
            new TableRow({
                children: [
                    new TableCell({
                        columnSpan: 3,
                        shading: { fill: '#8db3e2' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ children: [ new TextRun({ text: 'Cantidad de colaboradores/as', font: 'Arial', size: 24 }) ] }) ]
                    }),
                    new TableCell({
                        columnSpan: 3,
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ children: [ new TextRun({ text: `${instalacion.cantidadPersonal}`, font: 'Arial', size: 24 }) ] }) ]
                    })
                ]
            }),
            new TableRow({
                children: [
                    new TableCell({
                        columnSpan: 3,
                        shading: { fill: '#8db3e2' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ children: [ new TextRun({ text: 'Ubicación de la sede (provincia, cantón, distrito)', font: 'Arial', size: 24 }) ] }) ]
                    }),
                    new TableCell({
                        columnSpan: 3,
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ children: [ new TextRun({ text: `${instalacion.ubicacion} ${instalacion.direccion}`, font: 'Arial', size: 24 }) ] }) ]
                    })
                ]
            }),
            new TableRow({
                children: [
                    new TableCell({
                        columnSpan: 3,
                        shading: { fill: '#8db3e2' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ children: [ new TextRun({ text: 'Primera vez que presenta Informe Final (SI / NO)', font: 'Arial', size: 24 }) ] }) ]
                    }),
                    new TableCell({
                        columnSpan: 3,
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ children: [ new TextRun({ text: instalacion.tiempoEnPrograma > 0 ? "No" : "Si", font: 'Arial', size: 24 }) ] }) ]
                    })
                ]
            }),
            new TableRow({
                children: [
                    new TableCell({
                        columnSpan: 6,
                        shading: { fill: '#8db3e2' },
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({ 
                                alignment: AlignmentType.CENTER,
                                children: [ 
                                    new TextRun({ text: 'Historial de participación en la Categoría Cambio Climático', font: 'Arial', size: 24, bold: true }),
                                    new TextRun({ break: 1 }),
                                    new TextRun({ text: '(Si es primera vez que participan no completar. Para el histórico se contemplan 5 años anteriores)', font: 'Arial', size: 24 }) 
                                ] 
                            }) 
                        ]
                    })
                ]
            }),
            new TableRow({
                children: [
                    new TableCell({
                        rowSpan: 2,
                        shading: { fill: '#8db3e2' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: 'Año', font: 'Arial', size: 24 }) ] }) ]
                    }),
                    new TableCell({
                        columnSpan: 4,
                        shading: { fill: '#8db3e2' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: 'Resultado de la Evaluación', font: 'Arial', size: 24 }) ] }) ]
                    }),
                    new TableCell({
                        rowSpan: 2,
                        shading: { fill: '#8db3e2' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ text: 'Inscrita pero no presentó Informe Final', font: 'Arial', size: 24 }), new TextRun({ break: 1 }),  new TextRun({ text: '(marcar con X)', font: 'Arial', size: 16 }) ] }) ]
                    }),
                ]
            }),
            new TableRow({
                children: [
                    new TableCell({
                        shading: { fill: '#8db3e2' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({ 
                                alignment: AlignmentType.CENTER, 
                                children: [ 
                                    new TextRun({ text: 'Estrellas Blancas', font: 'Arial', size: 24 }), 
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: '(indicar número)', font: 'Arial', size: 16 }) 
                                ] 
                            }) 
                        ]
                    }),
                    new TableCell({
                        shading: { fill: '#8db3e2' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({ 
                                alignment: AlignmentType.CENTER, 
                                children: [ 
                                    new TextRun({ text: 'Estrella Verde', font: 'Arial', size: 24 }), 
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: '(marcar con X)', font: 'Arial', size: 16 }) 
                                ] 
                            }) 
                        ]
                    }),
                    new TableCell({
                        shading: { fill: '#8db3e2' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({ 
                                alignment: AlignmentType.CENTER, 
                                children: [ 
                                    new TextRun({ text: 'Estrella Plateada', font: 'Arial', size: 24 }), 
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: '(marcar con X)', font: 'Arial', size: 16 }) 
                                ] 
                            }) 
                        ]
                    }),
                    new TableCell({
                        shading: { fill: '#8db3e2' }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({ 
                                alignment: AlignmentType.CENTER, 
                                children: 
                                [ 
                                    new TextRun({ text: 'Estrella Anaranjada', font: 'Arial', size: 24 }), 
                                    new TextRun({ break: 1 }), 
                                    new TextRun({ text: '(marcar con X)', font: 'Arial', size: 16 }) 
                                ] 
                            }) 
                        ]
                    }),
                ]
            }),
        ];

        //agrega filas de datos
        if(Array.isArray(historial) && historial.length > 0) {
            historial.forEach(h => {
                let row = new TableRow({
                    children: [
                        new TableCell({
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.CENTER, 
                                    children: [ new TextRun({ text: `${this.blankData(h.anio)}`, font: 'Arial', size: 24 }) ] 
                                }) 
                            ]
                        }),
                        new TableCell({
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.CENTER, 
                                    children: [ new TextRun({ text: `${this.blankData(h.cantidadEstrellasBlancas)}`, font: 'Arial', size: 24 }) ] 
                                }) 
                            ]
                        }),
                        new TableCell({
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.CENTER, 
                                    children: [ new TextRun({ text: `${this.blankData(h.estrellaVerde)}`, font: 'Arial', size: 24 }) ] 
                                }) 
                            ]
                        }),
                        new TableCell({
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.CENTER, 
                                    children: [ new TextRun({ text: `${this.blankData(h.estrellaAnaranjada)}`, font: 'Arial', size: 24 }) ] 
                                }) 
                            ]
                        }),
                        new TableCell({
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.CENTER, 
                                    children: [ new TextRun({ text: `${this.blankData(h.estrellaPlateada)}`, font: 'Arial', size: 24 }) ] 
                                }) 
                            ]
                        }),
                        new TableCell({
                            verticalAlign: VerticalAlignTable.CENTER,
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.CENTER, 
                                    children: [ new TextRun({ text: `${this.blankData(h.inscrita)}`, font: 'Arial', size: 24 }) ] 
                                }) 
                            ]
                        }),
                    ]
                })
                dataRows.push(row)
            });
        } else {
            let emptyRow = this.emptyTableRow(6);//6 columnas
            dataRows.push(emptyRow)
        }
        let galardon = this.rowtituloImagem('Foto que demuestre, la iza o exhibición de la bandera, del galardón PBAE obtenido el año anterior', datos.galardon, 7, '#8db3e2');
        dataRows.push(...galardon)

        let generalidades = new Table({
            width: {
                size: 100,
                type: WidthType.PERCENTAGE,
            },
            rows: dataRows
        })

        return generalidades
    }

    tituloDobleConEvidencias(titulo, tituloDos, evidencias, color, tipoDocumento) {
        let evidenciasRows;
        let docs;
        
        if(tipoDocumento != null) {
            if(Array.isArray(tipoDocumento)) {
                docs = evidencias.filter(obj => tipoDocumento.includes(obj.idTipoDocumento)).map(obj => obj.evidencia);
            } else {
                docs = evidencias.filter(obj => obj.idTipoDocumento === tipoDocumento).map(obj => obj.evidencia);
            }
            evidenciasRows = this.evidenciasRows(docs, 1)
        } else {
            evidenciasRows = this.evidenciasRows(evidencias, 1)
        }
        let rows = [
            new TableRow({
                children: [
                    new TableCell({
                        shading: { fill: color }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({ 
                                alignment: AlignmentType.LEFT, 
                                children: [ 
                                    new TextRun({ text: titulo, font: 'Arial', bold: true, size: 24 })
                                ]
                            }) 
                        ] 
                    })
                ]
            }),
            new TableRow({
                children: [
                    new TableCell({
                        shading: { fill: color }, 
                        verticalAlign: VerticalAlignTable.CENTER,
                        children: [ 
                            new Paragraph({ 
                                alignment: AlignmentType.LEFT, 
                                children: [ 
                                    new TextRun({ text: tituloDos, font: 'Arial', size: 24 })
                                ]
                            }) 
                        ] 
                    }),
                ]
            })
        ]
        rows.push(...evidenciasRows)
        let tableEvid = new Table({
            width: {
                size: 100,
                type: WidthType.PERCENTAGE,
            },
            rows: rows
        })
        return tableEvid
    }

    estrellaVerPlatAnar2026(datos, tipoEstrella) {
        let estrella
        switch(tipoEstrella) {
            case 1:
                estrella = 'verde'
                break;
            case 2:
                estrella= 'plateada'
                break;
            case 3:
                estrella = 'anaranjada'
                break
        }
        let rows = []
        let encabezados = [
            this.setupColData(`Esta Sede opta por la estrella ${estrella} (marque con X)`, 50, 2, false, null, '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.CENTER),
            this.setupColData(`Información al respecto se presentó en el apartado respectivo del SIBAE (marque con X)`, 50, 2, false, null, '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.CENTER)
        ]
        rows.push(this.generateDataRowColObject(encabezados, null))
        if(datos != null && datos != undefined && datos.length > 0) {
            datos.forEach(d => {
                let sibae = tipoEstrella === 1 ? d.actSibae : d.sibae
                let sibaeSi = sibae ? 'X' : ''
                let sibaeNo = !sibae ? 'X' : ''
                let myRowSi = [
                    this.setupColData(`SI`, 20, 1, false, null, '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.CENTER),
                    this.setupColData(`X`, 30, 1, false, null, null, VerticalAlignTable.CENTER, AlignmentType.CENTER),
                    this.setupColData(`SI`, 20, 1, false, null, '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.CENTER),
                    this.setupColData(`${sibaeSi}`, 30, 1, false, null, null, VerticalAlignTable.CENTER, AlignmentType.CENTER),
                ]
                let myRowNo = [
                    this.setupColData(`NO`, 20, 1, false, null, '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.CENTER),
                    this.setupColData(``, 30, 1, false, null, null, VerticalAlignTable.CENTER, AlignmentType.CENTER),
                    this.setupColData(`NO`, 20, 1, false, null, '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.CENTER),
                    this.setupColData(`${sibaeNo}`, 30, 1, false, null, null, VerticalAlignTable.CENTER, AlignmentType.CENTER),
                ]
                rows.push(this.generateDataRowColObject(myRowSi, null))
                rows.push(this.generateDataRowColObject(myRowNo, null))
            })
        } else {
            rows.push(this.generateDataRowColObject(
                [
                    this.setupColData(`SI`, 20, 1, false, null, '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.CENTER),
                    this.setupColData(``, 30, 1, false, null, null, VerticalAlignTable.CENTER, AlignmentType.CENTER),
                    this.setupColData(`SI`, 20, 1, false, null, '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.CENTER),
                    this.setupColData(``, 30, 1, false, null, null, VerticalAlignTable.CENTER, AlignmentType.CENTER)
                ]
            ))
            rows.push(this.generateDataRowColObject(
                [
                    this.setupColData(`NO`, 20, 1, false, null, '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.CENTER),
                    this.setupColData(`X`, 30, 1, false, null, null, VerticalAlignTable.CENTER, AlignmentType.CENTER),
                    this.setupColData(`NO`, 20, 1, false, null, '#8db3e2', VerticalAlignTable.CENTER, AlignmentType.CENTER),
                    this.setupColData(`X`, 30, 1, false, null, null, VerticalAlignTable.CENTER, AlignmentType.CENTER)
                ]
            ))
        }

        let estrellaVerdeTable = new Table({
            width: {
                size: 100,
                type: WidthType.PERCENTAGE,
            },
            rows: rows
        })

        return estrellaVerdeTable
    }

    generateDataRowColObject(column, rowSpan, optRowColor) {
        let row = null
        let myRowSapn = rowSpan != null && rowSpan != undefined ? rowSpan : 1
        if(column != null && column != undefined && Array.isArray(column)) {
            let columns = []
            column.forEach(c => {
                let col = new TableCell({
                    columnSpan: c.colSpan,
                    shading: { fill: c.colColor, }, 
                    verticalAlign: c.verticalAlign,
                    width: { size: c.width, type: WidthType.PERCENTAGE },
                    children: [ 
                        new Paragraph({ 
                            alignment: c.horizontalAlign, 
                            children: [ 
                                new TextRun({ text: this.blankData(c.data), font: 'Arial', size: 24, bold: c.boldText, color: c.textColor })
                            ] 
                        }) 
                    ]
                })
                columns.push(col)
            })
            row = new TableRow({
                rowSpan: myRowSapn,
                children: columns
            })
        } else {
            if(column != null && column != undefined) {
                row = new TableRow({
                    children: [
                        new TableCell({
                            columnSpan: column.colSpan,
                            shading: { fill: column.colColor, },
                            verticalAlign: column.verticalAlign,
                            width: { size: 100, type: WidthType.PERCENTAGE },
                            children: [ 
                                new Paragraph({ 
                                    alignment: column.horizontalAlign, 
                                    children: [ 
                                        new TextRun({ text: this.blankData(column.data), font: 'Arial', size: 24, bold: column.boldText, color: column.textColor })
                                    ] 
                                }) 
                            ]
                        })
                    ]
                })
            } else {
                row = new TableRow({
                    children: [
                        new TableCell({
                            columnSpan: 1,
                            shading: { fill: optRowColor, },
                            verticalAlign: VerticalAlignTable.CENTER,
                            width: { size: 100, type: WidthType.PERCENTAGE },
                            children: [ 
                                new Paragraph({ 
                                    alignment: AlignmentType.CENTER, 
                                    children: [ 
                                        new TextRun({ text: this.blankData(null), font: 'Arial', size: 24, bold: false, color: '#000000' })
                                    ] 
                                }) 
                            ]
                        })
                    ]
                })
            }
        }
        
        return row
    }

    setupColData(data, width, colSpan, boldText, textColor, colColor, verticalAlign, horizontalAlign) {
        let column = {
            data: null,
            width: 10,
            colSpan: 1,
            boldText: false,
            textColor: '#000000',
            colColor: '#FFFFFF',
            verticalAlign: VerticalAlignTable.CENTER,
            horizontalAlign:  AlignmentType.CENTER,  
        }
        column.data = data
        column.width = width != null ? width : column.width
        column.colSpan = colSpan != null ? colSpan : column.colSpan
        column.boldText = boldText != null ? boldText : column.boldText
        column.textColor = textColor != null ? textColor : column.textColor
        column.colColor = colColor != null ? colColor : column.colColor
        column.verticalAlign = verticalAlign != null ? verticalAlign : column.verticalAlign
        column.horizontalAlign = horizontalAlign != null ? horizontalAlign : column.horizontalAlign

        return column
    }

    detectarTipoImagen(base64) {
        const prefijo = base64.split(',')[0].toLowerCase();

        if (prefijo.includes('image/png')) return 'png';
        if (prefijo.includes('image/jpeg') || prefijo.includes('image/jpg')) return 'jpg';
        if (prefijo.includes('image/gif')) return 'gif';
        if (prefijo.includes('image/bmp')) return 'bmp';

        throw new Error(`Formato de imagen no soportado: ${prefijo}`);
    }
}